export type Language = 'en' | 'cn' | 'uk' | 'ru';

export const TRANSLATIONS = {
    en: {
        // UI Labels
        'ui.title': 'Opalstone Kingdom',
        'ui.adminDashboard': "Commander's Archive",
        'ui.fullscreen': 'Fullscreen',
        'ui.exitFullscreen': 'Exit Fullscreen',
        'ui.nickname': 'Nickname',
        'ui.vs': 'VS',
        'ui.round': 'Round',
        'ui.night': 'Night',
        'ui.alphaWarning': 'ALPHA BUILD - EVERYTHING IS SUBJECT TO CHANGE',
        'ui.lifetimeAverage': 'Lifetime Average',

        // Phases
        'phase.transformTower': 'Transform Tower',
        'phase.yourResponse': 'Your Response!',
        'phase.opponentResponding': 'Opponent Responding...',
        'phase.claimTower': 'Round {round}: Claim Your Tower',
        'phase.chooseHeroClass': 'Round {round}: Choose Hero & Class',
        'phase.waitingOtherPlayer': 'Waiting for other player choice…',
        'phase.opponentChoosingStash': 'Another player is still thinking over cards...',
        'phase.setupComplete': 'Round {round}: Setup complete',
        'phase.acquireTower': 'Acquire a Tower',
        'phase.choosePurification': 'Choose Purification Target',
        'phase.choosePower': 'Round {round}: Choose Power',
        'phase.resolveOverflow': 'Resolve Locked Card Overflow',
        'phase.waiting': 'Waiting...',
        'phase.prepare': 'Round {round}: Prepare ({name} first tonight)',
        'phase.yourTurn': 'Your Turn',
        'phase.opponentTurn': "Opponent's Turn",
        'phase.nightEnds': 'Night {round} Ends...',
        'phase.gameOver': 'Game Over',

        // Stats
        'ui.stats.winRate': 'Win Rate',
        'ui.stats.bestClass': 'Best Class',
        'ui.stats.worstClass': 'Worst Class',
        'ui.stats.games': 'Games',

        // Card Descriptions
        'card.attack.desc': 'When used, it takes away 1 Health Point from the chosen opponent per one Red Card.',
        'card.pushback.desc': 'Returns any color deck card (or Armory Stash Deck card) played back to the opponent\'s hand. The effect of that card doesn\'t work.',
        'card.heal.desc': 'Removes all Disease reminders back to the green color deck and adds 1 Health Point, up to the player’s maximum Health Points.',
        'card.disease.desc': 'Each day, the player\'s Health Points are reduced by 1 for each Disease card they have.',
        'card.psy-search.desc': 'Draw two additional cards from the Draw Pile.',
        'card.psy-block.desc': 'Blocks any color deck card (or Artifact Stash Deck card) played by the opponent until the next night. The blocked card occupies a preparation slot.',
        'card.steal.desc': 'Steal one card from the opponent\'s hand at random.',
        'card.double-cross.desc': 'Cancels effect of any color deck cards. Both cards are removed from the game',
        'card.shock.desc': 'Reduces the number of cards that opponents can prepare on the next turn by 2. This effect applies only once to the next day phase.',
        'card.energize.desc': 'Increases your preparation limit by 2 cards for the following day (up to absolute maximum of 12). Effect resets after day phase.',
        'card.hibernation.desc': 'Avoid any following damage during the current night and following day. Take one card from color decks, but recieve no color deck cards next day.',
        'card.dispel.desc': 'Cancels only Yellow, Black, Green and Purple color deck cards played by opponent (as well as Spell Stash Deck card). Both cards are discarded to their decks.',
        'card.counterblast.desc': 'Reflect all damage back to the attacker.',
        'card.planted-bomb.desc': 'When your opponent plays a Stash Deck card, deal 5 damage to that opponent.',
        'card.chromabow.desc': '4 attack points. Draw any one card from the color decks of your choice.',
        'card.cursed-iron.desc': 'Reduce incoming damage by 1 until the end of the game. Transferred to reminders after play.',
        'card.discerning-eye.desc': 'The opponent must reveal all cards they prepare during the following day.',
        'card.ale.desc': 'Increase your preparation limit by 4 cards for the following day.',
        'card.energy-sword.desc': '2 attack points. Increase your preparation limit by 2 cards for the following day.',
        'card.eyes-of-madness.desc': 'Increase your preparation limit by 1 card until the end of the game. Transferred to reminders after play.',
        'card.flying-scythe.desc': '2 attack points. Deal 1 additional damage for every 2 Health Points the opponent is missing from their maximum.',
        'card.frost.desc': 'The opponent receives the Hibernation effect until the next night.',
        'card.inferno-gauntlet.desc': '4 attack points. If this attack reduces Health Points, the target discards two cards at random.',
        'card.invincible.desc': 'You are immune to any damage for two nights and one day.',
        'card.larcendagger.desc': '3 attack points. If this attack reduces Health Points, steal two cards from the target opponent.',
        'card.life-charger.desc': 'If you run out of Health Points while this card is prepared, immediately restore to maximum by paying Essence.',
        'card.life-drain.desc': 'The opponent loses 2 Health Points, while you restore the same amount.',
        'card.madness-control.desc': 'Increase your preparation limit by 4 cards until the end of the game. Transferred to reminders after play.',
        'card.natural-grip.desc': 'Opponent loses 2 Health Points per day. Put this card next to the opponent as a reminder. Can be cured by Healing.',
        'card.body-upgrade.desc': 'Increase hero\'s max health by 5 and add 5 HP.',
        'card.fortunes-favor.desc': 'Receive one extra card from the Draw Pile each day until the end of the game. Transferred to reminders after play.',
        'card.broken-secret.desc': 'Opponent reveals their hand. If they have a set of three identical cards, take one card from each set.',
        'card.steal-tower.desc': 'Capture any tower on the table (does not exceed the one tower per night limit).',
        'card.twilight-shift.desc': 'Skip the following Night.',
        'card.thunder-sprint.desc': 'Increase your preparation limit by 5 for the following day. You lose 3 Health Points.',
        'card.trembling.desc': 'The opponent loses Health Points equal to the number of cards they prepared for this night.',
        'card.protector.desc': '2 defense points or 2 attack points. Restore 1 Health Point.',
        'card.protector.chooseMode': 'Protector: Choose Mode',
        'card.protector.defenseLabel': 'Defense',
        'card.protector.attackLabel': 'Attack',
        'card.protector.defenseEffect': '+2 Defense',
        'card.protector.attackEffect': '2 Damage',
        'card.protector.passiveHeal': '+1 Health Point restored automatically',
        'card.arcane-boots.desc': 'Increase your preparation limit by 2 cards for the following day.',
        'card.card-cyclone.desc': 'Draw 3 cards.',
        'card.spikes.desc': 'When attacked, deal 1 damage to attacker.',
        'card.voodoo-doll.desc': 'Each time your cards deal damage to the opponent, that damage will be increased by +1. Save this card as a reminder.',
        'card.shadow-burglary.desc': 'Steal 1 card from opponent hand.',
        'card.ancient-sword.desc': '5 attack points.',
        'card.ancient-shield.desc': '5 defense points.',
        'card.shimmering-shield.desc': '2 defense points. Costs 5 Essence.',
        'card.steel-shield.desc': '2 defense points.',
        'card.the-sting.desc': '3 attack points.',
        'card.sword-of-revenge.desc': '8 attack points.',
        'card.paladins-hammer.desc': '3 attack points. Playable after pass.',
        'card.fireball.desc': '2 attack points.',
        'card.purification.desc': 'Capture a tower.',
        'card.seal-of-silence.desc': 'Prevent opponent from using spells/artifacts next turn.',

        'ui.endDay': 'End Day',
        'ui.pass': 'Pass',
        'ui.battleLog': 'Battle Log',
        'ui.activeChain': 'Active Chain',
        'ui.dropCounter': 'Drop Counter Here',
        'ui.waiting': 'Waiting',
        'ui.resolving': 'Resolving',
        'ui.noActiveChains': 'No active chains',
        'ui.noEventsYet': 'No events yet',
        'ui.accept': 'Accept',
        'ui.tapToClose': 'Tap to close',
        'ui.waitingOpponent': 'Waiting for opponent',
        'ui.yourMove': 'Your move',
        'ui.hand': 'Hand',
        'ui.essence': 'Essence',
        'ui.spells': 'Spells',
        'ui.preparation': 'Preparation',
        'ui.reminders': 'Transferred to reminders after play',
        'ui.shieldReaction': 'Shield reaction',
        'ui.playableAfterPass': 'Playable after Pass',
        'ui.welcomeBack': 'Welcome Back',
        'ui.joinKingdom': 'Join the Kingdom',
        'ui.chooseYourFaction': 'Choose Your Faction',
        'ui.victory': 'Victory!',
        'ui.defeat': 'Defeat!',
        'ui.draw': 'Draw!',
        'ui.victoryMsg': '{name} has won the duel! (+{fame} Fame)',
        'ui.victorySolo': '{name} has won the duel!',
        'ui.defeatMsg': '{name} has won the duel!',
        'ui.drawMsg': 'Both duelists have fallen!',
        'ui.name': 'Name',
        'ui.username': 'Username',
        'ui.password': 'Password',
        'ui.opalstoneId': 'Opalstone ID (OPTIONAL)',
        'ui.login': 'Login',
        'ui.register': 'Register',
        'ui.continue': 'Continue',
        'ui.nextGame': 'Next Game',
        'ui.confirm': 'Confirm',
        'ui.back': 'Back',
        'ui.paused': 'Paused',
        'ui.resume': 'Resume',
        'ui.options': 'Options',
        'ui.mainMenu': 'Main Menu',
        'ui.newGame': 'New Game',
        'ui.worldMap': 'World Map',
        'ui.myProfile': 'My Profile',
        'ui.quit': 'Quit',
        'ui.playAgain': 'Play Again',
        'ui.toMenu': 'To Menu',

        'ui.opponent': 'Opponent',
        'ui.selectGameMode': 'Select Game Mode',
        'ui.withAI': 'With AI',
        'ui.multiplayer': 'Multiplayer',
        'ui.aiBusters': 'AI Busters',
        'ui.noRecordsYet': 'No records yet',
        'ui.createRoom': 'Create Room',
        'ui.joinRoom': 'Join Room',
        'ui.beginJourney': 'Begin Journey',
        'ui.switchToLogin': 'Already a member? Login',
        'ui.switchToRegister': 'New to the Kingdom? Create account',
        'ui.newToKingdom': 'New to the Kingdom? Create an Account',
        'ui.alreadyHaveAccount': 'Already have an account? Login',
        'ui.confirmFaction': 'Confirm Faction',
        'ui.selected': 'Selected',
        'ui.clickAgainToConfirm': 'Click again to confirm',
        'ui.selectAllegiance': 'Select your allegiance wisely, {username}',
        'error.nameLength': 'Name must be at least 2 characters',
        'error.passwordLength': 'Password must be at least 6 characters',
        'error.opalFormat': 'Opalstone ID must be 8 digits',
        'error.opalInvalid': 'Opalstone ID is invalid or unavailable',
        'error.chooseFaction': 'Please choose a faction',
        'error.network': 'Network error (check console)',
        'error.loginFailed': 'Login failed',
        'error.registrationFailed': 'Registration failed',
        'ui.loadingAuth': 'Loading...',
        'ui.enterName': 'Enter your name',
        'ui.enterPassword': 'Enter password',
        'ui.enterOpalId': '8-digit ID (Optional)',
        'ui.enterRealm': 'Enter Realm',
        'ui.stashShop': 'Stash Deck Shop',
        'ui.resurrectFromAsh': 'Resurrect from Ash',
        'ui.selectCardCount': 'Select {count} card(s)',
        'ui.stashOptions': 'Stash Options',
        'ui.burnedPile': 'Burned Pile',
        'ui.confirmChoice': 'CONFIRM CHOICE',
        'ui.faction': 'Faction',
        'ui.controlPoints': 'Control Points',
        'ui.heroes': 'Heroes',
        'ui.neutralZone': 'Neutral Zone',
        'ui.noHeroBound': 'No hero bound to this zone.',
        'ui.close': 'Close',
        'ui.backToMenu': 'Back to Menu',
        'ui.level': 'Lvl',
        'ui.okId': 'OK ID',
        'ui.editProfile': 'Edit Profile',
        'ui.save': 'Save',
        'ui.cancel': 'Cancel',
        'ui.famePoints': 'Fame Points',
        'ui.mostWanted': 'MOST WANTED',
        'ui.justDefeatedAI': 'Just Defeated AI',
        'ui.winRate': 'Win Rate',
        'ui.arcanePower': 'Arcane Power',
        'ui.fameLevelHint': 'Fame Level determines which emotes you can use in animated slots.',
        'ui.slot': 'Slot',
        'ui.selectEmote': 'Select Emote for Slot',
        'ui.lvl': 'Lvl',
        'ui.heroesCollection': 'Collection',
        'ui.tab.heroes': 'Heroes',
        'ui.tab.emotes': 'Emotes',
        'ui.collected': 'Collected',
        'ui.viewGallery': 'View Gallery',
        'ui.totalMatches': 'Total Matches',
        'ui.viewHistory': 'View History',
        'ui.statistics': 'Statistics',
        'emote.PIECE': 'Peace',
        'emote.SMIRK': 'Smirk',
        'emote.ANGER': 'Anger',
        'emote.SAD': 'Sadness',
        'emote.SHOCKED': 'Shock',
        'emote.THANKS': 'Respect',
        'ui.stat.wins': 'Wins',
        'ui.stat.losses': 'Losses',
        'ui.stat.winstreak': 'Best Winstreak',
        'ui.stat.totalDamage': 'Total Damage Dealt',
        'ui.matchHistory': 'Match History',
        'ui.stats.heroStats': 'Hero Stats',
        'ui.stats.matchupHeatmap': 'Matchup Heatmap',
        'ui.stats.classEffectiveness': 'Class Effectiveness',
        'ui.stats.heroVsClass': 'Hero vs Class',

        'ui.stats.noData': 'Not enough data',
        'ui.victoryScreen': 'VICTORY',
        'ui.drawScreen': 'DRAW',
        'ui.defeatScreen': 'DEFEAT',
        'ui.noMatchesYet': 'No matches recorded yet.',
        'ui.noHeroesYet': 'No heroes collected yet.',
        'ui.winToCapture': 'Win games to capture heroes!',
        'ui.faction.harmonized': 'Harmonized',
        'ui.faction.chaotic': 'Chaotic',
        'ui.faction.untouched': 'Untouched',
        'ui.faction.none': 'None',
        'term.zone': 'Zone',
        'ui.waitingForPlayer': 'Waiting for player...',
        'ui.host': 'Host',
        'ui.setupSelected': 'Setup Selected',
        'ui.choosing': 'Choosing...',
        'ui.ready': 'Ready',
        'ui.notReady': 'Not Ready',
        'ui.lobby': 'Lobby',
        'ui.setNotReady': 'Set Not Ready',
        'ui.selectHeroAndClass': 'Select Hero & Class',
        'ui.readyUp': 'Ready Up',
        'ui.startGame': 'Start Game',
        'ui.leave': 'Leave',
        'ui.setupYourChampion': 'Setup Your Champion',
        'ui.chooseHero': 'Choose Hero',
        'ui.chooseClass': 'Choose Class',
        'ui.selectHeroAndClassPrompt': 'Select a Hero and Class to proceed.',
        'ui.readyToLockIn': 'You are ready to lock in.',
        'ui.choiceHiddenPrompt': 'Your choice is hidden from opponent until game starts.',
        'ui.chooseHeroAndClass': 'Choose Hero and Class',
        'ui.classes': 'Classes',
        'ui.claimYourTower': 'Claim Your Tower',
        'ui.towerChoiceDesc': 'Choose your tower color - it will provide you one card per turn of the same color.',
        'ui.towerPurchaseDesc': 'Which tower to capture? Discard cards of the same color. Collect 5 towers to win!',
        'ui.purificationDesc': 'Choose a tower to capture instantly with your Purification spell.',
        'ui.towerChangeDesc': 'Choose a new color for your tower to change your strategy.',
        'ui.transformTower': 'Transform Tower',
        'ui.noColorCard': '(No {color} card)',
        'ui.isChoosingHeroClass': 'is choosing Hero and Class.',
        'ui.isChoosingTower': 'is choosing starting tower',
        'ui.notSet': 'Not set',
        'ui.loadingMap': 'Loading map',
        'ui.lobbyChat': 'Lobby Chat',
        'ui.sayHello': 'Say hello to your opponent...',
        'ui.typeMessage': 'Type a message...',
        'ui.send': 'Send',
        'multiplayer.createRoom': 'Create a Room',
        'multiplayer.joinRoom': 'Join a Room',
        'multiplayer.roomName': 'Room Name',
        'multiplayer.roomNamePlaceholder': 'Enter room name...',
        'multiplayer.privateRoom': 'Private Room',
        'multiplayer.setPassword': 'Set password for room',
        'multiplayer.passwordPlaceholder': 'Enter password...',
        'multiplayer.connecting': 'Connecting to server...',
        'multiplayer.disconnected': 'Disconnected from server.',
        'multiplayer.noRooms': 'No rooms available',
        'multiplayer.noRoomsMatch': 'No rooms match your search',
        'multiplayer.refresh': 'Refresh',
        'multiplayer.back': 'Back',
        'multiplayer.create': 'Create Room',
        'multiplayer.join': 'Join',
        'multiplayer.cancel': 'Cancel',
        'multiplayer.passwordRequired': 'Password Required',
        'multiplayer.availableRooms': 'Available Rooms',
        'multiplayer.host': 'Host',
        'multiplayer.enterPasswordFor': 'Enter password for',
        'multiplayer.searchPlaceholder': 'Search by room name...',
        'multiplayer.confirmQuitMessage': 'You will lose your current game progress. Are you sure you want to return to the main menu?',
        'multiplayer.confirmQuitAppMessage': 'You will lose your current game progress. Are you sure you want to quit?',
        'multiplayer.abandonWarning': 'By leaving an unfinished match you will lose fame points (rating). In the Opalstone Kingdom you can always turn the battle in your favor! Are you sure you want to leave the game?',
        'ui.technicalVictory': 'Technical Victory! Your opponent has been penalized for abandoning the match!',
        'ui.fameSummary': 'Fame earned: +{fame}',
        'ui.fameSummaryNone': 'No fame earned (match too short)',
        'ui.areYouSure': 'Are you sure?',
        'ui.switchingRoom': 'Switching room...',
        'multiplayer.opponentDisconnectTimeout': 'Opponent left the game (connection timed out)',
        'multiplayer.hostDisconnected': 'Host disconnected from the game.',
        'error.lobbyFull': 'Lobby is full',
        'error.lobbyNotFound': 'Lobby not found',
        'error.lobbyUnavailable': 'Lobby unavailable',
        'error.sessionAlreadyActive': 'Game session is already active in another tab',
        'term.match': 'Match',
        'term.essence': 'Essence',
        'ui.chooseZoneToCapture': 'CHOOSE A ZONE TO CAPTURE',
        'ui.idleHintDayTitle': 'Day: What can you do?',
        'ui.idleHintDayLine1': '1. Prepare or return cards from preparation slots.',
        'ui.idleHintDayLine2': '2. Rotate cards before or after preparation.',
        'ui.idleHintDayLine3': '3. Click Essence button to enter Essence earning mode.',
        'ui.idleHintDayLine4': '',
        'ui.idleHintDayLine5': '',
        'ui.idleHintNightTitle': 'Night: What can you do?',
        'ui.idleHintNightLine1': '1. Play cards from preparation slots on your turn or as a response.',
        'ui.idleHintNightLine2': '2. Rotate cards before playing to choose an effect.',
        'ui.idleHintNightLine3': '3. Click Essence button to enter Essence earning mode.',
        'ui.idleHintNightLine4': '4. Change your towers color.',
        'ui.idleHintNightLine5': '5. Capture new towers.',
        'term.shieldReaction': 'Shield reaction',
        'term.playableAfterPass': 'Playable after Pass',
        'term.prepare-for-battle': 'Prepare for battle!',

        // General Terms
        'term.chaotic': 'Chaotic',
        'term.harmonized': 'Harmonized',
        'term.untouched': 'Untouched',
        'term.neutral': 'Neutral',
        'term.opalstoneKingdom': 'Opalstone Kingdom',
        'term.warrior': 'Warrior',
        'term.mage': 'Mage',
        'term.occultist': 'Occultist',

        'class.WARRIOR.name': 'Warrior',
        'class.WARRIOR.desc': 'The Warrior is a powerful and flexible class. The first Armory Stash Deck card the Warrior prepares during the day will increase preparation limit by 1.',
        'class.MAGE.name': 'Mage',
        'class.MAGE.desc': 'The Mage is the class that requires the most wisdom. The Mage can play Spell Stash Deck cards from their hand at night without preparation. Spell cards played this way must be discarded into the Stash deck. Also, the Mage is able to save 2 cards out of 5 cards drawn from the Stash Deck each day.',
        'class.OCCULTIST.name': 'Occultist',
        'class.OCCULTIST.desc': 'The Occultist is strong at every stage of the game. The Occultist pays half the cost for Artifact Stash Deck cards.',

        'hero.NORIM.name': 'Norim',
        'hero.NORIM.desc': 'Every third Stash Deck card burned for 8 Essence instead of 4.',
        'hero.TERRIK.name': 'Terrik',
        'hero.TERRIK.desc': 'Each prepared color deck card that is discarded at night will grant 3 Essence per card.',
        'hero.EVELION.name': 'Evelion',
        'hero.EVELION.desc': 'If the opponent loses Health Points from your cards, you restore the same amount of Health Points.',
        'hero.CORIL.name': 'Coril',
        'hero.CORIL.desc': 'Takes to his hand any Stash Deck card of the opponent cancelled by his counter-actions.',
        'hero.ASTRID.name': 'Astrid',
        'hero.ASTRID.desc': 'When discarding three same color cards in one night, deal 2 inevitable damage to a chosen opponent.',
        'hero.FERRIM.name': 'Ferrim',
        'hero.FERRIM.desc': 'When using the Stash deck, you can either check the Stash deck cards or the burnt pile of Stash cards.',
        'hero.VERISK.name': 'Verisk',
        'hero.VERISK.desc': "Copying opponent's hero.",
        'hero.EROK_BURU.name': 'Erok-Buru',
        'hero.EROK_BURU.desc': 'Every 2 points lost from the maximum Health Points gives one extra preparation slot on the table.',
        'hero.VERG.name': 'Verg',
        'hero.VERG.desc': 'Every 3 points lost from the opponent\'s maximum Health Points gives one extra preparation slot.',
        'hero.NYRIX.name': 'Nyrix',
        'hero.NYRIX.desc': 'Doubles the power of all Green Effects. Opponents "Healing" removes only one Disease instead of all Disease reminders.',
        'hero.SHANU.name': 'Shanu',
        'hero.SHANU.desc': 'Restores full maximum Health Points when using Hibernation effect for two nights in a row.',
        'hero.LORIAN.name': 'Lorian',
        'hero.LORIAN.desc': 'Able to change its class at the beginning of every new turn',
        'hero.GEMATA.name': 'Gemata',
        'hero.GEMATA.desc': 'When burning cards from the Stash Deck, Essence is not received. Instead, draw three additional cards from the Draw Pile.',
        'hero.TRIFLE.name': 'Trifle',
        'hero.TRIFLE.desc': 'When burning a Stash Deck card, draw one card from color decks for each tower you own.',
        'term.lorian': 'Lorian',

        'ui.acquireTower': 'Acquire a Tower',
        'ui.choosePurificationTarget': 'Choose Purification Target',
        'ui.cost': 'Cost: ',
        'ui.cardsSuffix': ' cards',
        'ui.stealFromOpponent': 'Steal',
        'ui.claimNeutral': 'Neutral',
        'color.red': 'RED',
        'color.green': 'GREEN',
        'color.black': 'BLACK',
        'color.purple': 'PURPLE',
        'color.pink': 'PINK',
        'color.yellow': 'YELLOW',
        'term.attack': 'Attack',
        'term.pushback': 'Pushback',
        'term.defense': 'Defense',
        'term.heal': 'Heal',
        'term.disease': 'Disease',
        'term.psy-search': 'Psy-Search',
        'term.psy-block': 'Psy-Block',
        'term.steal': 'Steal',
        'term.double-cross': 'Double Cross',
        'term.shock': 'Shock',
        'term.energize': 'Energize',
        'term.hibernation': 'Hibernation',
        'term.dispel': 'Dispel',
        'term.counterblast': 'Counterblast',
        'term.planted-bomb': 'Planted Bomb',
        'term.chromabow': 'Chromabow',
        'term.cursed-iron': 'Cursed Iron',
        'term.discerning-eye': 'Discerning Eye',
        'term.ale': 'Ale',
        'term.energy-sword': 'Energy Sword',
        'term.eyes-of-madness': 'Eyes of Madness',
        'term.flying-scythe': 'Flying Scythe',
        'term.frost': 'Frost',
        'term.inferno-gauntlet': 'Inferno Gauntlet',
        'term.invincible': 'Invincible',
        'term.larcendagger': 'Larcendagger',
        'term.life-charger': 'Life Charger',
        'term.life-drain': 'Life Drain',
        'term.madness-control': 'Madness Control',
        'term.natural-grip': 'Natural Grip',
        'term.body-upgrade': 'Body Upgrade',
        'term.fortunes-favor': 'Fortune\'s Favor',
        'term.broken-secret': 'Broken Secret',
        'term.steal-tower': 'Steal Tower',
        'term.twilight-shift': 'Twilight Shift',
        'term.thunder-sprint': 'Thunder Sprint',
        'term.trembling': 'Trembling',
        'term.protector': 'Protector',
        'term.arcane-boots': 'Arcane Boots',
        'term.red': 'Red',
        'term.pink': 'Pink',
        'term.green': 'Green',
        'term.black': 'Black',
        'term.purple': 'Purple',
        'term.yellow': 'Yellow',
        'ui.specialEffect': 'Special effect card',

        // Stash Deck Card Names
        'card.ancient-sword.name': 'Ancient Sword',
        'card.chromabow.name': 'Chromabow',
        'card.ancient-shield.name': 'Ancient Shield',
        'card.shimmering-shield.name': 'Shimmering Shield',
        'card.steel-shield.name': 'Steel Shield',
        'card.spikes.name': 'Spikes',
        'card.energy-sword.name': 'Energy Sword',
        'card.flying-scythe.name': 'Flying Scythe',
        'card.inferno-gauntlet.name': 'Inferno Gauntlet',
        'card.larcendagger.name': 'Larcendagger',
        'card.the-sting.name': 'The Sting',
        'card.sword-of-revenge.name': 'Sword of Revenge',
        'card.paladins-hammer.name': "Paladin's Hammer",
        'card.fireball.name': 'Fireball',
        'card.purification.name': 'Purification',
        'card.card-cyclone.name': 'Card Cyclone',
        'card.life-drain.name': 'Life Drain',
        'card.counterblast.name': 'Counterblast',
        'card.eyes-of-madness.name': 'Eyes of Madness',
        'card.frost.name': 'Frost',
        'card.invincible.name': 'Invincible',
        'card.natural-grip.name': 'Natural Grip',
        'card.shadow-burglary.name': 'Shadow Burglary',
        'card.twilight-shift.name': 'Twilight Shift',
        'card.thunder-sprint.name': 'Thunder Sprint',
        'card.trembling.name': 'Trembling',
        'card.planted-bomb.name': 'Planted Bomb',
        'card.protector.name': 'Protector',
        'card.body-upgrade.name': 'Body Upgrade',
        'card.fortunes-favor.name': "Fortune's Favor",
        'card.arcane-boots.name': 'Arcane Boots',
        'card.discerning-eye.name': 'Discerning Eye',
        'card.broken-secret.name': 'Broken Secret',
        'card.cursed-iron.name': 'Cursed Iron',
        'card.ale.name': 'Ale',
        'card.life-charger.name': 'Life Charger',
        'card.madness-control.name': 'Madness Control',
        'card.seal-of-silence.name': 'Seal of Silence',
        'card.voodoo-doll.name': 'Voodoo Doll',

        // Stash Deck Cards
        'hero.AXEL.name': 'Axel',
        'hero.AXEL.desc': 'Unused colored cards in preparation slots return to hand, and add a copy of themselves from their respective color decks.',
        'log.axelAbility': '{playerName}\'s Axel ability copies a {cardType} card!',

        // Log Messages
        'log.roundStart': 'Round {round} - Choose your tower!',
        'log.towerChose': '{playerName} chose the {towerColor} tower.',
        'log.towerClaimed': '{playerName}\'s Purification claims the neutral {targetColor} tower!',
        'log.towerStole': '{playerName}\'s Purification steals the {targetColor} tower from {defenderName}!',
        'log.towerNoTarget': '{playerName}\'s Purification finds no towers to claim.',
        'log.towerFizzle': '{playerName}\'s Purification fizzles - already captured a tower this night.',
        'log.stashExhausted': 'Stash Deck exhausted! Card choice phase skipped.',
        'log.stashRefresh': 'Refreshing {playerName}\'s stash options...',
        'log.silenced': '{playerName} is silenced and cannot play {cardType} cards this night.',
        'log.lifeChargerBlocked': '{loserName}\'s Life Charger was blocked! {loserName} has fallen!',
        'log.victorious': '{playerName} is victorious!',
        'log.lifeChargerRestore': '{playerName}\'s Life Charger restores them to full health! The battle continues.',
        'log.immunityPrevented': '{targetName}\'s immunity prevents {damage} reflected damage from {sourceName}\'s Counterblast!',
        'log.counterblastReflect': '{sourceName}\'s Counterblast reflects {damage} damage to {targetName}!',
        'log.lifeChargerAuto': '{playerName}\'s Life Charger activates automatically to prevent death!',
        'log.draw': 'It\'s a draw!',
        'log.alreadyCaptured': '{playerName} has already captured a tower this night.',
        'log.towerNotAvailable': 'That tower is not available to capture.',
        'log.notEnoughCards': '{playerName} does not have enough {towerColor} cards.',
        'log.towerTransform': '{playerName} transforms a {oldColor} tower into a {newColor} tower.',
        'log.cannotUseDirect': '{playerName} cannot use {cardName} as a direct action.',
        'log.shieldOnly': '{playerName} can only play shield cards now!',
        'log.lockedCard': '{playerName} cannot use this locked card yet!',
        'log.notEnoughEssence': '{playerName} does not have enough essence!',
        'log.payEssence': '{playerName} pays {essence} essence.',
        'log.attemptActivate': '{playerName} attempts to activate a {cardType} card!',
        'log.activateCard': '{playerName} activates a {cardType} card!',
        'log.silencePinkSpell': '{playerName} can only use Seal of Silence against a Pink or Spell initial action.',
        'log.plantedBombChain': '{playerName} cannot use Planted Bomb without an active chain.',
        'log.plantedBombStash': '{playerName} can only use Planted Bomb against Stash Deck cards.',
        'log.defenseActionOnly': '{playerName} can only use {cardName} against a damage-dealing action.',
        'log.succumbed': '{playerName} has succumbed to daily damage!',
        'log.drawFromTower': '{playerName} drew a {towerColor} card from their tower.',
        'log.hibernatingTowers': '{playerName} is hibernating and does not draw from towers.',
        'log.hibernatingDeck': '{playerName} is hibernating and does not draw from the deck.',
        'log.twilightShift': 'Twilight Shift effect: night skipped, an extra day begins.',
        'log.nightMarker': '--- Night {round} ---',
        'log.lorianChoice': '{playerName} must choose a class for the day.',
        'log.zonePoint': 'Victory point assigned to Zone {zoneId}. Control: {control}.',
        'log.neutral': 'Neutral',
        'log.pureHarmonized': 'Harmonized',
        'log.pureChaotic': 'Chaotic',
        'log.pureUntouched': 'Untouched',
        'log.doubleCrossInitial': 'Double-Cross cannot be used as an initial reaction.',
        'log.invalidCounter': 'Invalid counter attempt.',
        'log.counterWith': '{playerName} counters with a {cardType}!',
        'log.heroClassSelected': '{playerName} selected Hero {hero} and Class {playerClass}.',
        'log.lorianChoiceRefined': '{playerName} chose class {playerClass} for the day.',
        'log.oneMoreStash': '{playerName} can pick one more Stash card.',
        'log.bodyUpgradeLog': '{playerName} upgrades their body, gaining {value} max HP!',
        'log.fortunesFavorLog': '{playerName} gains Fortune\'s Favor, and will draw an extra card each day!',
        'log.cursedIronLog': '{playerName} is now protected by Cursed Iron, reducing all future damage by 1.',
        'log.eyesOfMadnessLog': '{playerName}\'s Eyes of Madness permanently grants 1 prep slot!',
        'log.madnessControlLog': '{playerName}\'s Madness Control permanently grants {value} prep slots!',
        'log.brokenSecretLog': '{playerName}\'s Broken Secret reveals {defenderName}\'s hand!',
        'log.stolenCardsLog': '{playerName} steals {count} card(s) from {defenderName}!',
        'log.noSetsFoundLog': 'No sets were found in {defenderName}\'s hand.',
        'log.invincibleLog': '{playerName} becomes Invincible!',
        'log.fizzledLog': '{cardType} fizzles as the original attack is no longer valid.',
        'log.invincibleAnywayLog': '{playerName} becomes Invincible anyway!',
        'log.immuneLog': '{playerName} is immune to the reflected damage!',
        'log.invincibleBlockLog': '{playerName} becomes Invincible, blocking the attack!',
        'log.bombImmuneLog': '{playerName} is immune to the Planted Bomb!',
        'log.bombCursedIronLog': '{playerName}\'s Cursed Iron reduces damage by {reduction}.',
        'log.bombExplodeLog': '{playerName}\'s Planted Bomb explodes, dealing {damage} damage to {targetName}!',
        'log.protectorReactionLog': '{playerName}\'s Protector grants {value} shield as a reaction.',
        'log.protectorAttackLog': '{playerName}\'s Protector attacks {targetName} for {damage} damage.',
        'log.protectorNegatedLog': '{playerName}\'s Protector attack on {targetName} is negated by immunity.',
        'log.protectorDefenseLog': '{playerName}\'s Protector grants {value} shield.',
        'log.protectorRestoreLog': '{playerName} restores {value} health from Protector.',
        'log.chromabowNegatedLog': '{playerName}\'s Chromabow is negated by {defenderName}\'s immunity.',
        'log.chromabowDamageLog': '{playerName}\'s Chromabow deals {damage} damage to {defenderName}.',
        'log.chromabowDrawLog': '{playerName}\'s Chromabow grants a card from the {color} deck!',
        'log.slotOverflowLog': '{playerName}\'s locked {cardType} returns to hand (slot overflow).',
        'log.lockedReturnSlot': '{playerName}\'s locked {cardType} returns to hand (slot overflow).',
        'log.effectExpireDiscard': '{playerName}\'s {cardType} effect expires and is discarded.',
        'log.effectExpireReturn': '{playerName}\'s {cardType} effect expires and returns to hand.',
        'log.lockedReturn': '{playerName}\'s locked {cardType} returns to hand.',
        'log.chooseLocked': '{playerName} must choose which locked cards to return (slot overflow).',
        'log.immuneDisease': '{playerName} is immune to daily damage.',
        'log.cursedIronReduce': '{playerName}\'s Cursed Iron reduces daily damage by {damage}.',

        // Options Menu
        'ui.optionsTitle': 'Options',
        'ui.optionsMusicVolume': 'Music Volume',
        'ui.optionsSoundVolume': 'Sound Effects',
        'ui.optionsEffects': 'Effects & Animations',
        'ui.optionsTooltips': 'Tooltips',
        'ui.optionsActionHints': 'Action Hints',
        'ui.optionsInstructor': 'Instructor Guide',
        'instructor.pred.prepare_card': 'prepare it for the night',
        'instructor.pred.attempt_activation': 'activate its effect',
        'instructor.pred.counter_activation': 'counter the opponent\'s action',
        'instructor.pred.end_day': 'end the preparation phase',
        'instructor.pred.pass': 'pass the turn',
        'instructor.pred.purchase_tower': 'capture a new tower',
        'instructor.purchase_tower_hint': "Try clicking towers' crystals area at the bottom of the screen to capture a new tower of {colorName} color!",
        'instructor.pred.mage_cast_spell': 'cast a spell',
        'instructor.pred.accept_activation': 'accept the effects',
        'instructor.pred.toggle_essence_mode': 'enter essence earning mode',
        'instructor.pred.toggle_essence_mode_off': 'exit essence earning mode',
        'instructor.pred.start_tower_purchase': 'start capturing a tower',
        'instructor.pred.discard_stash': 'burn it for essence',
        'instructor.pred.discard_hand_for_essence': 'discard it to get essence',
        'instructor.pred.astrid_blast': 'use your hero ability',
        'instructor.astrid_blast_hint': "Try playing [Astrid's Arrows button] to deal inevitable damage to the opponent! To do that, drag and drop arrow from the button to the opponent's avatar.",
        'instructor.pred.default': 'make the optimal move',
        'instructor.flip_first': 'Before using [{elementName}], flip it to [{targetSideName}] (mouse wheel or arrows icon).',
        'instructor.drag_to_prepare': 'Drag [{elementName}] into an empty preparation slot.',
        'instructor.tryPlaying': 'Try playing {cardName} to {prediction}.',
        'instructor.tryPlayingTarget': 'Try playing {cardName} to {prediction}. To do that, drag and drop {cardName} on the target.',
        'instructor.tryClicking': 'Try clicking {elementName} to {prediction}.',
        'instructor.close': 'Close (this tip)',
        'instructor.turnOff': 'Turn Off Instructor',
        'instructor.drag_arrow_hint': 'Try dragging the arrow from the card to the target avatar by holding the mouse cursor or finger on the card.',
        'instructor.title': 'Instructor Tip',
        'instructor.chooseLockedCardReturn': 'It seems you have more locked cards than slots. Choose [{elementName}] to return it to your hand.',
        'instructor.chooseBurglaryCard': 'Choose [{elementName}] from opponent\'s hand.',
        'instructor.chooseColor': 'Choose [{colorName}] color.',
        'instructor.choosePurificationTarget': 'Choose [{colorName}] tower.',
        'ui.on': 'On',
        'ui.off': 'Off',
        'admin.title': "Commander's Archive (Admin)",
        'admin.back': 'Back',
        'admin.enterCode': 'Enter Commander Code:',
        'admin.wrongCode': 'Incorrect code. The guard has been notified.',
        'admin.tie': 'Balance (Tie)',
        'admin.zones': 'Zone Management',
        'admin.zone': 'Zone',
        'admin.pointsUpdated': 'Zone {id} points updated!',
        'admin.pointsFailed': 'Update failed',
        'admin.siegeTitle': 'Zone 4 Siege',
        'admin.heroId': 'Hero ID:',
        'admin.startSiege': 'Start Siege',
        'admin.siegeResetWarning': '* Starting event will reset timer to 0.',
        'admin.siegeStarted': 'Siege started with hero {id}!',
        'admin.siegeFailed': 'Start failed',
        'admin.veriskMonitor': 'Verisk Monitor',
        'admin.weakest': 'Weakest:',
        'admin.strongest': 'Strongest:',
        'admin.zone4Owner': 'Zone 4 Owner:',
        'admin.veriskCondition': 'Verisk Condition:',
        'admin.veriskHolders': 'Verisk Holders:',
        'admin.conditionMet': 'MET',
        'admin.conditionNotMet': 'NOT MET',
        'admin.none': 'None',
        'admin.neutral': 'Neutral',
        'admin.userAccess': 'User Access',
        'admin.makeAdmin': 'Make Admin',
        'admin.adminSuccess': '{user} is now Admin!',
        'admin.loading': 'Loading Admin Archive...',
        'admin.advanced': 'Advanced User Management',
        'admin.resetAll': 'Reset All Progress',
        'admin.deleteAll': 'Delete All (Except Me)',
        'admin.resetUser': 'Reset Progress',
        'admin.deleteUser': 'Delete User',
        'admin.banUser': 'Ban User',
        'admin.unbanUser': 'Unban User',
        'admin.confirmResetAll': 'Are you sure you want to reset ALL player progress? This cannot be undone.',
        'admin.confirmDeleteAll': 'Are you sure you want to delete ALL users? Only you will remain.',
        'admin.confirmAction': 'Are you sure you want to {action} user {user}?',
        'admin.actionSuccess': 'Action successful!',
        'admin.userNotFound': 'User not found.',
        'error.banned': 'Account blocked due to suspicious activity.',

        // Notifications
        'notif.title': 'Notifications',
        'notif.noNotifications': 'No notifications',
        'notif.markAllRead': 'Mark all as read',
        'notif.clearAll': 'Clear all',
        'notif.zoneCaptured': 'Zone {zone} was captured by {faction}!',
        'notif.heroBelongs': 'Hero "{hero}" now belongs to {faction}',
        'notif.factionCapturedTavern': 'Our faction captured the tavern (Zone {zone})! Hero "{hero}" is now permanently in our collection!',
        'notif.factionReinforcements': 'Reinforcements arrived! Check your hero collection! Hero {hero} will help us advance on the world map!',
        'notif.opalstoneGift': 'Gift for entering Opalstone ID! New hero "{hero}" in your collection!',
        'notif.accountBlocked': 'Your account has been blocked by an administrator.',
        'notif.accountUpdate': 'Account update: {message}',
        'notif.global': 'Global',
        'notif.faction': 'Faction',
        'notif.individual': 'Personal',
    },
    cn: {
        // UI Labels
        'ui.title': 'Opalstone Kingdom',
        'ui.adminDashboard': '指挥官档案馆',
        'ui.fullscreen': '全屏',
        'ui.exitFullscreen': '退出全屏',
        'ui.nickname': '昵称',
        'ui.vs': 'VS',
        'ui.round': '回合',
        'ui.night': '夜晚',
        'ui.alphaWarning': 'Alpha 版本 - 所有内容可能会更改',
        'ui.lifetimeAverage': '生涯平均',

        // Phases
        'phase.transformTower': '转化塔楼',
        'phase.yourResponse': '你的响应！',
        'phase.opponentResponding': '对手响应中...',
        'phase.claimTower': '第 {round} 回合：占领你的塔楼',
        'phase.chooseHeroClass': '第 {round} 回合：选择英雄和职业',
        'phase.waitingOtherPlayer': '等待其他玩家选择...',
        'phase.opponentChoosingStash': '另一位玩家还在思考卡牌中...',
        'phase.setupComplete': '第 {round} 回合：设置完成',
        'phase.acquireTower': '获取塔楼',
        'phase.choosePurification': '选择净化目标',
        'phase.choosePower': '第 {round} 回合：选择力量',
        'phase.resolveOverflow': '解决锁定卡牌溢出',
        'phase.waiting': '等待中...',
        'phase.prepare': '第 {round} 回合：准备（今晚 {name} 先手）',
        'phase.yourTurn': '你的回合',
        'phase.opponentTurn': '对手的回合',
        'phase.nightEnds': '第 {round} 夜结束...',
        'phase.gameOver': '游戏结束',

        // Stats
        'ui.stats.winRate': '胜率',
        'ui.stats.bestClass': '最佳职业',
        'ui.stats.worstClass': '最差职业',
        'ui.stats.games': '场次',

        // Card Descriptions
        'card.attack.desc': '使用时，每有一张红牌，就会扣除所选对手 1 点生命值。',
        'card.pushback.desc': '将对手打出的任何颜色套牌卡（或军械库藏匿卡）退回其手牌。该卡的效果无效。',
        'card.heal.desc': '将所有疾病提醒卡移回绿色牌堆，并增加 1 点生命值，上限为玩家的最大生命值。',
        'card.disease.desc': '每天，玩家每拥有一张疾病卡，生命值减少 1 点。',
        'card.psy-search.desc': '从牌堆额外抽取两张牌。',
        'card.psy-block.desc': '封锁对手打出的任何颜色套牌卡（或神器藏匿卡），持续到第二天晚上。被封锁的卡占据一个准备槽位。',
        'card.steal.desc': '随机从对手手牌中窃取一张牌。',
        'card.double-cross.desc': '取消任何颜色套牌卡的效果。两张卡都移出游戏。',
        'card.shock.desc': '使对手下回合可准备的卡牌数量减少 2 张。此效果仅对下一个白天阶段生效一次。',
        'card.energize.desc': '使你第二天的准备上限增加 2 张（绝对上限为 12 张）。效果在白天阶段后重置。',
        'card.hibernation.desc': '在当前夜晚和接下来的白天避免任何后续伤害。从颜色牌堆拿一张牌，但第二天不通过颜色牌堆获得牌。',
        'card.dispel.desc': '仅取消对手打出的黄色、黑色、绿色和紫色套牌卡（以及法术藏匿卡）。两张卡都弃入各自的牌堆。',
        'card.counterblast.desc': '将所有伤害反射给攻击者。',
        'card.planted-bomb.desc': '当你的对手打出藏匿卡时，对该对手造成 5 点伤害。',
        'card.chromabow.desc': '4 点攻击力。从你选择的颜色牌堆中抽取任意一张牌。',
        'card.cursed-iron.desc': '直到游戏结束，受到的伤害减少 1 点。打出后移至提醒区。',
        'card.discerning-eye.desc': '对手必须展示他们在接下来的一天中准备的所有卡牌。',
        'card.ale.desc': '使你第二天的准备上限增加 4 张。',
        'card.energy-sword.desc': '2 点攻击力。使你第二天的准备上限增加 2 张。',
        'card.eyes-of-madness.desc': '使你的准备上限增加 1 张，直到游戏结束。打出后移至提醒区。',
        'card.flying-scythe.desc': '2 点攻击力。对手每损失 2 点生命值（相对于最大值），额外造成 1 点伤害。',
        'card.frost.desc': '对手受到冬眠效果影响，直到第二天晚上。',
        'card.inferno-gauntlet.desc': '4 点攻击力。如果此攻击减少了生命值，目标随机弃掉两张牌。',
        'card.invincible.desc': '你在两个晚上和一个白天内免疫任何伤害。',
        'card.larcendagger.desc': '3 点攻击力。如果此攻击减少了生命值，从目标对手处窃取两张牌。',
        'card.life-charger.desc': '如果准备此卡时生命值耗尽，支付精华立即恢复至最大值。',
        'card.life-drain.desc': '对手失去 2 点生命值，同时你恢复等量生命值。',
        'card.madness-control.desc': '使你的准备上限增加 4 张，直到游戏结束。打出后移至提醒区。',
        'card.natural-grip.desc': '对手每天失去 2 点生命值。将此卡放在对手旁边作为提醒。可以通过治疗治愈。',
        'card.body-upgrade.desc': '增加英雄最大生命值 5 点并回复 5 点生命值。',
        'card.fortunes-favor.desc': '每天从抽牌堆额外获得一张牌，直到游戏结束。打出后移至提醒区。',
        'card.broken-secret.desc': '对手展示手牌。如果有三张相同的卡且成套，从每套中抽取一张。',
        'card.steal-tower.desc': '占领桌面上的任意一座塔（不超过每晚一座塔的限制）。',
        'card.twilight-shift.desc': '跳过接下来的夜晚。',
        'card.thunder-sprint.desc': '使你第二天的准备上限增加 5 张。你失去 3 点生命值。',
        'card.trembling.desc': '对手失去的生命值等于他们今晚准备的卡牌数量。',
        'card.protector.desc': '2 点防御力或 2 点攻击力。恢复 1 点生命值。',
        'card.protector.chooseMode': '保护者：选择模式',
        'card.protector.defenseLabel': '防御',
        'card.protector.attackLabel': '攻击',
        'card.protector.defenseEffect': '+2 护盾',
        'card.protector.attackEffect': '2 伤害',
        'card.protector.passiveHeal': '+1 生命值自动恢复',
        'card.arcane-boots.desc': '使你第二天的准备上限增加 2 张。',
        'card.card-cyclone.desc': '抽 3 张牌。',
        'card.spikes.desc': '受到攻击时，对攻击者造成 1 点伤害。',
        'card.voodoo-doll.desc': '每当你的卡片对对手造成伤害时，该伤害将增加 +1。保留此卡作为提醒。',
        'card.shadow-burglary.desc': '从对手手牌中窃取 1 张牌。',
        'card.ancient-sword.desc': '5 点攻击力。',
        'card.ancient-shield.desc': '5 点防御力。',
        'card.shimmering-shield.desc': '2 点防御力。消耗 5 点精华。',
        'card.steel-shield.desc': '2 点防御力。',
        'card.the-sting.desc': '3 点攻击力。',
        'card.sword-of-revenge.desc': '8 点攻击力。',
        'card.paladins-hammer.desc': '3 点攻击力。可在过牌后打出。',
        'card.fireball.desc': '2 点攻击力。',
        'card.purification.desc': '占领一座塔。',
        'card.seal-of-silence.desc': '阻止对手下回合使用法术/神器。',

        'ui.endDay': '结束白天',
        'ui.pass': '跳过回合',
        'ui.battleLog': '战斗日志',
        'ui.activeChain': '当前链条',
        'ui.dropCounter': '在此拖放反击卡',
        'ui.waiting': '等待中',
        'ui.resolving': '结算中',
        'ui.noActiveChains': '暂无活跃链条',
        'ui.noEventsYet': '暂无事件',
        'ui.accept': '接受',
        'ui.tapToClose': '点击关闭',
        'ui.waitingOpponent': '等待对手...',
        'ui.yourMove': '轮到你了',
        'ui.hand': '手牌',
        'ui.essence': '灵力',
        'ui.spells': '法术',
        'ui.preparation': '准备',
        'ui.reminders': '已转至提醒',
        'ui.shieldReaction': '护盾反应',
        'ui.playableAfterPass': '跳过后可玩',
        'ui.welcomeBack': '欢迎回来',
        'ui.joinKingdom': '加入王国',
        'ui.chooseYourFaction': '选择你的阵营',
        'ui.victory': '胜利！',
        'ui.defeat': '战败！',
        'ui.draw': '平局！',
        'ui.victoryMsg': '{name} 赢得了决斗！ (+{fame} 声望)',
        'ui.victorySolo': '{name} 赢得了决斗！',
        'ui.defeatMsg': '{name} 赢得了决斗！',
        'ui.drawMsg': '双方都倒下了！',
        'ui.name': '名字',
        'ui.username': '用户名',
        'ui.password': '密码',
        'ui.opalstoneId': '欧泊石 ID (可选)',
        'ui.login': '登录',
        'ui.register': '注册',
        'ui.playAgain': '再玩一次',
        'ui.toMenu': '返回菜单',
        'ui.continue': '继续',
        'ui.nextGame': '下一场游戏',
        'ui.confirm': '确认',
        'ui.back': '返回',
        'ui.paused': '已暂停',
        'ui.resume': '继续游戏',
        'ui.options': '选项',
        'ui.mainMenu': '主菜单',
        'ui.newGame': '新游戏',
        'ui.worldMap': '世界地图',
        'ui.myProfile': '我的资料',
        'ui.quit': '退出',
        'ui.opponent': '对手',
        'ui.selectGameMode': '选择游戏模式',
        'ui.withAI': '与 AI 对战',
        'ui.multiplayer': '多人游戏',
        'ui.aiBusters': 'AI 终结者',
        'ui.noRecordsYet': '暂无记录',
        'ui.createRoom': '创建房间',
        'ui.joinRoom': '加入房间',
        'ui.beginJourney': '开始旅程',
        'ui.switchToLogin': '已经是成员了？登录',
        'ui.switchToRegister': '加入王国？创建账号',
        'ui.newToKingdom': '加入王国？创建账号',
        'ui.alreadyHaveAccount': '已经是成员了？登录',
        'ui.confirmFaction': '确认阵营',
        'ui.selected': '已选择',
        'ui.clickAgainToConfirm': '再次点击确认',
        'ui.selectAllegiance': '明智地选择你的效忠对象，{username}',
        'error.nameLength': '名字必须至少为 2 个字符',
        'error.passwordLength': '密码必须至少为 6 个字符',
        'error.opalFormat': '欧泊石 ID 必须为 8 位数字',
        'error.opalInvalid': '欧泊石 ID 无效或已被占用',
        'error.chooseFaction': '请选择一个阵营',
        'error.network': '网络错误（查看控制台）',
        'error.loginFailed': '登录失败',
        'error.registrationFailed': '注册失败',
        'ui.loadingAuth': '加载中...',
        'ui.enterName': '输入你的名字',
        'ui.enterPassword': '输入密码',
        'ui.enterOpalId': '8位ID (可选)',
        'ui.enterRealm': '进入领域',
        'ui.stashShop': 'Stash Deck 商店',
        'ui.resurrectFromAsh': '死灰复燃',
        'ui.selectCardCount': '选择 {count} 张卡牌',
        'ui.stashOptions': 'Stash 选项',
        'ui.burnedPile': '已消耗堆',
        'ui.confirmChoice': '确认选择',
        'ui.faction': '阵营',
        'ui.controlPoints': '控制点',
        'ui.heroes': '英雄',
        'ui.neutralZone': '中立区域',
        'ui.noHeroBound': '本区域未绑定英雄。',
        'ui.close': '关闭',
        'ui.backToMenu': '返回菜单',
        'ui.level': '等级',
        'ui.okId': 'OK ID',
        'ui.editProfile': '编辑个人资料',
        'ui.save': '保存',
        'ui.cancel': '取消',
        'ui.famePoints': '声望点',
        'ui.mostWanted': '通缉令',
        'ui.justDefeatedAI': '刚刚击败AI',
        'ui.winRate': '胜率',
        'ui.arcanePower': '奥术能量',
        'ui.fameLevelHint': '声望等级决定了你可以在动画槽位中使用的表情。',
        'ui.slot': '槽位',
        'ui.selectEmote': '选择表情',
        'ui.heroesCollection': '收藏',
        'ui.tab.heroes': '英雄',
        'ui.tab.emotes': '表情',
        'ui.collected': '已收集',
        'ui.viewGallery': '查看画廊',
        'ui.totalMatches': '总场次',
        'ui.viewHistory': '查看历史',
        'ui.statistics': '统计',
        'emote.PIECE': '和平',
        'emote.SMIRK': '得逞',
        'emote.ANGER': '愤怒',
        'emote.SAD': '悲伤',
        'emote.SHOCKED': '震惊',
        'emote.THANKS': '尊敬',
        'ui.stat.wins': '胜场',
        'ui.stat.losses': '败场',
        'ui.stat.winstreak': '最佳连胜',
        'ui.stat.totalDamage': '总伤害',
        'ui.matchHistory': '比赛历史',
        'ui.stats.heroStats': '英雄统计',
        'ui.stats.matchupHeatmap': '对战热图',
        'ui.stats.classEffectiveness': '职业效率',
        'ui.stats.heroVsClass': '英雄对职业',

        'ui.stats.noData': '数据不足',
        'ui.victoryScreen': '胜利',
        'ui.drawScreen': '平局',
        'ui.defeatScreen': '失败',
        'ui.noMatchesYet': '尚无比赛记录。',
        'ui.noHeroesYet': '尚无收集的英雄。',
        'ui.winToCapture': '赢得比赛以捕捉英雄！',
        'ui.faction.harmonized': '和谐',
        'ui.faction.chaotic': '混乱',
        'ui.faction.untouched': '超然',
        'ui.faction.none': '无',
        'term.zone': '区域',
        'ui.waitingForPlayer': '等待玩家...',
        'ui.host': '房主',
        'ui.setupSelected': '设置已选择',
        'ui.choosing': '选择中...',
        'ui.ready': '准备就绪',
        'ui.notReady': '未准备',
        'ui.lobby': '大厅',
        'ui.setNotReady': '设置未准备',
        'ui.selectHeroAndClass': '选择英雄和职业',
        'ui.readyUp': '准备好了',
        'ui.startGame': '开始游戏',
        'ui.leave': '离开',
        'ui.setupYourChampion': '设置你的英雄',
        'ui.chooseHero': '选择英雄',
        'ui.chooseClass': '选择职业',
        'ui.selectHeroAndClassPrompt': '请选择英雄和职业以继续。',
        'ui.readyToLockIn': '你已准备好锁定。',
        'ui.choiceHiddenPrompt': '在游戏开始前，对手无法看到你的选择。',
        'ui.chooseHeroAndClass': '选择英雄和职业',
        'ui.classes': '职业',
        'ui.claimYourTower': '认领你的塔楼',
        'ui.towerChoiceDesc': '选择你的塔楼颜色——它每回合将为你提供一张相同颜色的卡牌。',
        'ui.towerPurchaseDesc': '要占领哪座塔楼？弃掉相同颜色的卡牌。收集5座塔楼即可获胜！',
        'ui.purificationDesc': '选择一座塔楼，用净化法术立即占领。',
        'ui.towerChangeDesc': '为你的塔楼选择新颜色以改变策略。',
        'ui.transformTower': '变换塔楼',
        'ui.noColorCard': '(没有{color}卡)',
        'ui.isChoosingHeroClass': '正在选择英雄和职业。',
        'ui.isChoosingTower': '正在选择初始塔楼',
        'ui.notSet': '未设置',
        'ui.loadingMap': '正在加载地图',
        'ui.lobbyChat': '大厅聊天',
        'ui.sayHello': '向你的对手打个招呼吧...',
        'ui.typeMessage': '输入消息...',
        'ui.send': '发送',
        'multiplayer.createRoom': '创建房间',
        'multiplayer.joinRoom': '加入房间',
        'multiplayer.roomName': '房间名称',
        'multiplayer.roomNamePlaceholder': '输入房间名称...',
        'multiplayer.privateRoom': '私密房间',
        'multiplayer.setPassword': '设置房间密码',
        'multiplayer.passwordPlaceholder': '输入密码...',
        'multiplayer.connecting': '正在连接服务器...',
        'multiplayer.disconnected': '已与服务器断开连接',
        'multiplayer.noRooms': '暂无可加入房间',
        'multiplayer.noRoomsMatch': '没有匹配的房间',
        'multiplayer.refresh': '刷新',
        'multiplayer.back': '返回',
        'multiplayer.create': '创建房间',
        'multiplayer.join': '加入',
        'multiplayer.cancel': '取消',
        'multiplayer.passwordRequired': '需要密码',
        'multiplayer.availableRooms': '可用房间',
        'multiplayer.host': '房主',
        'multiplayer.enterPasswordFor': '输入密码',
        'multiplayer.searchPlaceholder': '按房间名搜索...',
        'multiplayer.confirmQuitMessage': '你将失去当前的游玩进度。你确定要返回主菜单吗？',
        'multiplayer.confirmQuitAppMessage': '你将失去当前的游玩进度。你确定要退出吗？',
        'multiplayer.abandonWarning': '离开未完成的比赛将扣除声望值（评分）。在欧帕石王国，你随时都能扭转战局！你确定要离开对战吗？',
        'ui.technicalVictory': '技术胜利！对手因弃赛已被处罚！',
        'ui.fameSummary': '获得声望：+{fame}',
        'ui.fameSummaryNone': '未获得声望（对战时间不足）',
        'ui.areYouSure': '你确定吗？',
        'ui.switchingRoom': '正在切换房间...',
        'multiplayer.opponentDisconnectTimeout': '对手已离开游戏（连接超时）',
        'multiplayer.hostDisconnected': '房主已断开游戏连接。',
        'error.lobbyFull': '房间已满',
        'error.lobbyNotFound': '房间未找到',
        'error.lobbyUnavailable': '房间不可用',
        'error.sessionAlreadyActive': '游戏会话已在另一个标签页中活跃',
        'term.match': '比赛',
        'term.essence': '灵力',
        'ui.chooseZoneToCapture': '选择一个区域进行占领',
        'ui.idleHintDayTitle': '白天：你能做什么？',
        'ui.idleHintDayLine1': '1. 从准备槽中准备或退回卡牌。',
        'ui.idleHintDayLine2': '2. 在准备前或准备后旋转卡牌。',
        'ui.idleHintDayLine3': '3. 点击精华按钮进入精华赚取模式。',
        'ui.idleHintDayLine4': '',
        'ui.idleHintDayLine5': '',
        'ui.idleHintNightTitle': '夜晚：你能做什么？',
        'ui.idleHintNightLine1': '1. 在你的回合或作为响应从准备槽中打出卡牌。',
        'ui.idleHintNightLine2': '2. 打出前旋转卡牌以选择效果。',
        'ui.idleHintNightLine3': '3. 点击精华按钮进入精华赚取模式。',
        'ui.idleHintNightLine4': '4. 更改防御塔颜色。',
        'ui.idleHintNightLine5': '5. 占领新的防御塔。',
        'term.shieldReaction': '护盾反应',
        'term.playableAfterPass': '跳过回合后可玩',
        'term.prepare-for-battle': '准备战斗！',

        // General Terms
        'term.chaotic': '混沌者',
        'term.harmonized': '调和者',
        'term.untouched': '纯粹者',
        'term.neutral': '中立',
        'term.opalstoneKingdom': '欧泊王国',
        'term.warrior': '战士',
        'term.mage': '法师',
        'term.occultist': '术士',

        'class.WARRIOR.name': '战士',
        'class.MAGE.name': '法师',
        'class.OCCULTIST.name': '术士',

        'hero.NORIM.name': '诺瑞姆',
        'hero.TERRIK.name': '泰瑞克',
        'hero.EVELION.name': '伊维利昂',
        'hero.CORIL.name': '科瑞尔',
        'hero.ASTRID.name': '阿丝婷',
        'hero.FERRIM.name': '火知仁',
        'hero.VERISK.name': '威诺斯',
        'hero.EROK_BURU.name': '恶鲁克布鲁',
        'hero.VERG.name': '韦尔格',
        'hero.NYRIX.name': '尼蕊柯丝',
        'hero.SHANU.name': '莎努',
        'hero.LORIAN.name': '洛瑞安',
        'hero.GEMATA.name': '吉玛塔',
        'hero.TRIFLE.name': '琐菲',
        'term.lorian': '洛里安',

        'ui.acquireTower': '获取一座塔',
        'ui.choosePurificationTarget': '选择净化目标',
        'ui.cost': '花费：',
        'ui.cardsSuffix': ' 张卡牌',
        'ui.stealFromOpponent': '窃取',
        'ui.claimNeutral': '中立',
        'color.red': '红色',
        'color.green': '绿色',
        'color.black': '黑色',
        'color.purple': '紫色',
        'color.pink': '粉色',
        'color.yellow': '黄色',
        'term.attack': '攻击',
        'term.pushback': '推回',
        'term.defense': '防御',
        'term.heal': '治疗',
        'term.disease': '疾病',
        'term.psy-search': '心灵搜索',
        'term.psy-block': '心灵封锁',
        'term.steal': '偷窃',
        'term.double-cross': '双重背叛',
        'term.shock': '休克',
        'term.energize': '充能',
        'term.hibernation': '冬眠',
        'term.dispel': '驱散',
        'term.counterblast': '反击爆破',
        'term.planted-bomb': '埋设炸弹',
        'term.chromabow': '炫彩弓',
        'term.cursed-iron': '被诅咒的铁',
        'term.discerning-eye': '洞察之眼',
        'term.ale': '麦芽酒',
        'term.energy-sword': '能量剑',
        'term.eyes-of-madness': '疯狂之眼',
        'term.flying-scythe': '飞镰',
        'term.frost': '霜冻',
        'term.inferno-gauntlet': '地狱手套',
        'term.invincible': '无敌',
        'term.larcendagger': '贼刃',
        'term.life-charger': '生命充能',
        'term.life-drain': '生命汲取',
        'term.madness-control': '疯狂控制',
        'term.natural-grip': '自然之握',
        'term.body-upgrade': '身体升级',
        'term.fortunes-favor': '命运的青睐',
        'term.broken-secret': '破碎的秘密',
        'term.steal-tower': '窃取塔楼',
        'term.twilight-shift': '暮色转换',
        'term.thunder-sprint': '雷霆冲刺',
        'term.trembling': '发抖',
        'term.protector': '保护者',
        'term.arcane-boots': '奥术靴',
        'term.red': '红色',
        'term.pink': '粉色',
        'term.green': '绿色',
        'term.black': '黑色',
        'term.purple': '紫色',
        'term.yellow': '黄色',
        'ui.specialEffect': '特殊效果卡',

        'card.ale.name': '埃尔啤酒',
        'card.protector.name': '守护者',
        'card.planted-bomb.name': '炸弹植入',
        'card.arcane-boots.name': '奥术靴',
        'card.energy-sword.name': '能量之剑',
        'card.flying-scythe.name': '飞镰',
        'card.frost.name': '冻结',
        'card.life-charger.name': '生命充能器',
        'card.madness-control.name': '疯魔控制',
        'card.spikes.name': '刺棘',
        'card.thunder-sprint.name': '雷霆冲刺',
        'card.seal-of-silence.name': '寂静之印',
        'card.voodoo-doll.name': '巫毒娃娃',
        'card.chromabow.name': '炫彩弓',
        'card.the-sting.name': '刺钉剑',
        'card.broken-secret.name': '破碎的秘密',
        'card.ancient-sword.name': '远古之剑',
        'card.ancient-shield.name': '远古护盾',
        'card.shimmering-shield.name': '闪耀之盾',
        'card.steel-shield.name': '钢铁之盾',
        'card.inferno-gauntlet.name': '烈火护手',
        'card.larcendagger.name': '贼刃',

        'card.sword-of-revenge.name': '复仇之剑',
        'card.paladins-hammer.name': '圣骑士之锤',
        'card.purification.name': '净化',
        'card.card-cyclone.name': '卡牌飓风',
        'card.life-drain.name': '生命汲取',
        'card.counterblast.name': '绝地反击',
        'card.eyes-of-madness.name': '疯狂之眼',
        'card.fireball.name': '火球术',
        'card.shadow-burglary.name': '暗影之窃',
        'card.twilight-shift.name': '跳转黄昏',
        'card.trembling.name': '颤抖',
        'card.discerning-eye.name': '审视之眼',
        'card.cursed-iron.name': '邪咒之铁',
        'card.body-upgrade.name': '机体升级',
        'card.fortunes-favor.name': '幸运祝福',
        'card.natural-grip.name': '自然控扼',
        'card.invincible.name': '无懈可击',



        'hero.NORIM.desc': '每销毁三张秘宝牌，第三张卡牌将获得8点灵力，而不是4点。',

        'hero.TERRIK.desc': '在夜晚丢弃已准备的颜色卡牌时，每张卡牌将获得3点灵力。',
        'hero.EVELION.desc': '如果对手因你的卡牌而失去生命值，你将恢复等量的生命值。',
        'hero.CORIL.desc': '通过反击行动取消对手的秘宝牌时，将其收入手中。',
        'hero.ASTRID.desc': '在同一夜晚丢弃三张相同颜色的卡牌时，对选定的对手造成2点必然伤害。',
        'hero.FERRIM.desc': '使用 Stash 牌组时，你可以查看 Stash 牌组或已消耗的 Stash 卡堆。',
        'hero.VERISK.desc': '复制对手的英雄。',
        'hero.EROK_BURU.desc': '生命值每减少2点，桌面上的卡牌准备位就增加一个。',
        'hero.VERG.desc': '对手的生命值每减少3点，你的卡牌准备位就增加一个。',
        'hero.NYRIX.desc': '所有绿色效果增强一倍。对手的“治疗”只能移除一种疾病提醒，而不是全部。',
        'hero.SHANU.desc': '连续两晚使用冬眠效果时，恢复全部最大生命值。',
        'hero.LORIAN.desc': '能够在每个新回合开始时更改其职业',
        'hero.GEMATA.desc': '从秘宝牌组中销毁卡牌时，不会获得灵力。相反，从抽牌堆中额外抽取三张卡牌。',
        'hero.TRIFLE.desc': '每当消耗一张秘宝卡（Stash Deck）时，你拥有的每一座塔楼都会额外提供 +1 张卡。',
        'class.WARRIOR.desc': '战士是一个强大且灵活的职业。战士在白天准备的第一张 Armory 秘宝牌将使卡牌准备上限增加1。',
        'class.MAGE.desc': '法师是需要最高智慧的职业。法师可以在夜晚直接从手中展示 Spell 秘宝牌而无需准备。以此方式展示的法术牌必须丢弃回秘宝牌组。此外，法师每天可以从抽取的5张秘宝牌中保留2张。',
        'class.OCCULTIST.desc': '术士在游戏的每个阶段都很强大。术士购买 Artifact 秘宝牌只需支付一半的费用。',

        // Log Messages
        'log.roundStart': '第 {round} 轮 - 选择你的塔！',
        'log.towerChose': '{playerName} 选择了 {towerColor} 塔。',
        'log.towerClaimed': '{playerName} 的净化点占领了中立的 {targetColor} 塔！',
        'log.towerStole': '{playerName} 的净化点从 {defenderName} 手中夺取了 {targetColor} 塔！',
        'log.towerNoTarget': '{playerName} 的净化点没有找到可占领的塔。',
        'log.towerFizzle': '{playerName} 的净化点失效了 - 今晚已经占领了一座塔。',
        'log.stashExhausted': 'Stash 牌组已耗尽！跳过选牌阶段。',
        'log.stashRefresh': '正在刷新 {playerName} 的 Stash 选项...',
        'log.silenced': '{playerName} 被沉默了，今晚不能使用 {cardType} 卡。',
        'log.lifeChargerBlocked': '{loserName} 的生命充能器被阻挡了！{loserName} 倒下了！',
        'log.victorious': '{playerName} 获得了胜利！',
        'log.lifeChargerRestore': '{playerName} 的生命充能器使其恢复至满血！战斗继续。',
        'log.immunityPrevented': '{targetName} 的免疫效果防止了来自 {sourceName} 反击爆破的 {damage} 点反弹伤害！',
        'log.counterblastReflect': '{sourceName} 的反击爆破对 {targetName} 反弹了 {damage} 点伤害！',
        'log.lifeChargerAuto': '{playerName} 的生命充能器自动激活以防止死亡！',
        'log.draw': '平局！',
        'log.alreadyCaptured': '{playerName} 今晚已经占领了一座塔。',
        'log.towerNotAvailable': '该塔不可占领。',
        'log.notEnoughCards': '{playerName} 没有足够的 {towerColor} 卡牌。',
        'log.towerTransform': '{playerName} 将一座 {oldColor} 塔转化为一座 {newColor} 塔。',
        'log.cannotUseDirect': '{playerName} 不能将 {cardName} 作为直接行动使用。',
        'log.shieldOnly': '{playerName} 现在只能出护盾牌！',
        'log.lockedCard': '{playerName} 还不能使用这张锁定的卡牌！',
        'log.notEnoughEssence': '{playerName} 没有足够的精华！',
        'log.payEssence': '{playerName} 支付了 {essence} 点精华。',
        'log.attemptActivate': '{playerName} 尝试激活一张 {cardType} 卡！',
        'log.activateCard': '{playerName} 激活了一张 {cardType} 卡！',
        'log.silencePinkSpell': '{playerName} 只能对 Pink 或 Spell 初始行动使用 Seal of Silence。',
        'log.plantedBombChain': '{playerName} 不能在没有活跃链的情况下使用 Planted Bomb。',
        'log.plantedBombStash': '{playerName} 只能对 Stash 牌组卡牌使用 Planted Bomb。',
        'log.defenseActionOnly': '{playerName} 只能对伤害类行动使用 {cardName}。',
        'log.succumbed': '{playerName} 死于每日伤害！',
        'log.drawFromTower': '{playerName} 从他们的塔中抽取了一张 {towerColor} 卡。',
        'log.hibernatingTowers': '{playerName} 正在冬眠，不从塔中抽牌。',
        'log.hibernatingDeck': '{playerName} 正在冬眠，不从牌组中抽牌。',
        'log.twilightShift': '暮光转移效应：跳过夜晚，额外的一天开始。',
        'log.nightMarker': '--- 第 {round} 晚 ---',
        'log.lorianChoice': '{playerName} 必须为今天选择一个职业。',
        'log.zonePoint': '胜利点已分配给区域 {zoneId}。控制权：{control}。',
        'log.neutral': '中立',
        'log.pureHarmonized': 'Harmonized',
        'log.pureChaotic': 'Chaotic',
        'log.pureUntouched': 'Untouched',
        'log.doubleCrossInitial': 'Double-Cross 不能作为初始反应使用。',
        'log.invalidCounter': '无效的反击尝试。',
        'log.counterWith': '{playerName} 用一张 {cardType} 进行反击！',
        'log.heroClassSelected': '{playerName} 选择了英雄 {hero} 和职业 {playerClass}。',
        'log.lorianChoiceRefined': '{playerName} 为今天选择了职业 {playerClass}。',
        'log.oneMoreStash': '{playerName} 可以再选择一张秘宝牌。',
        'log.bodyUpgradeLog': '{playerName} 升级了身体，获得 {value} 点最大生命值！',
        'log.fortunesFavorLog': '{playerName} 获得了命运的青睐，每天将额外抽取一张卡牌！',
        'log.cursedIronLog': '{playerName} 现在受到被诅咒的铁保护，减少未来所有伤害 1 点。',
        'log.eyesOfMadnessLog': '{playerName} 的疯狂之眼永久授予 1 个准备位！',
        'log.madnessControlLog': '{playerName} 的疯狂控制永久授予 {value} 个准备位！',
        'log.brokenSecretLog': '{playerName} 的破碎秘密揭示了 {defenderName} 的手牌！',
        'log.stolenCardsLog': '{playerName} 从 {defenderName} 处偷走了 {count} 张卡牌！',
        'log.noSetsFoundLog': '在 {defenderName} 的手中没有发现套装。',
        'log.invincibleLog': '{playerName} 变得无敌了！',
        'log.fizzledLog': '{cardType} 失效了，因为原始攻击已不再有效。',
        'log.invincibleAnywayLog': '{playerName} 依然变得无敌了！',
        'log.immuneLog': '{playerName} 对反弹伤害免疫！',
        'log.invincibleBlockLog': '{playerName} 变得无敌，抵挡了攻击！',
        'log.bombImmuneLog': '{playerName} 对埋设炸弹免疫！',
        'log.bombCursedIronLog': '{playerName} 的被诅咒的铁减少了 {reduction} 点伤害。',
        'log.bombExplodeLog': '{playerName} 的埋设炸弹爆炸，对 {targetName} 造成 {damage} 点伤害！',
        'log.protectorReactionLog': '{playerName} 的保护者作为反应获得 {value} 点护盾。',
        'log.protectorAttackLog': '{playerName} 的保护者攻击 {targetName} 造成 {damage} 点伤害。',
        'log.protectorNegatedLog': '{playerName} 的保护者对 {targetName} 的攻击被免疫抵消。',
        'log.protectorDefenseLog': '{playerName} 的保护者获得 {value} 点护盾。',
        'log.protectorRestoreLog': '{playerName} 通过保护者恢复了 {value} 点生命值。',
        'log.chromabowNegatedLog': '{playerName} 的炫彩弓被 {defenderName} 的免疫抵消。',
        'log.chromabowDamageLog': '{playerName} 的炫彩弓对 {defenderName} 造成 {damage} 点伤害。',
        'log.chromabowDrawLog': '{playerName} 的炫彩弓从 {color} 卡堆中获得一张卡！',
        'log.slotOverflowLog': '{playerName} 的锁定卡 {cardType} 返回手中（位置溢出）。',
        'log.lockedReturnSlot': '{playerName} 的锁定卡 {cardType} 返回手中（位置溢出）。',
        'log.effectExpireDiscard': '{playerName} 的 {cardType} 效果过期并被丢弃。',
        'log.effectExpireReturn': '{playerName} 的 {cardType} 效果过期并返回手中。',
        'log.lockedReturn': '{playerName} 的锁定卡 {cardType} 返回手中。',
        'log.chooseLocked': '{playerName} 必须选择要退回哪些锁定的卡牌（位置溢出）。',
        'log.immuneDisease': '{playerName} 对每日伤害免疫。',
        'log.cursedIronReduce': '{playerName} 的被诅咒的铁减少了每日伤害 {damage}。',

        // Options Menu
        'ui.optionsTitle': '选项',
        'ui.optionsMusicVolume': '音乐音量',
        'ui.optionsSoundVolume': '音效音量',
        'ui.optionsEffects': '特效与动画',
        'ui.optionsTooltips': '提示信息',
        'ui.optionsActionHints': '行动提示',
        'ui.optionsInstructor': '指导员指南',
        'instructor.pred.prepare_card': '为夜晚准备它',
        'instructor.pred.attempt_activation': '激活它的效果',
        'instructor.pred.counter_activation': '反击对手的行动',
        'instructor.pred.end_day': '结束准备阶段',
        'instructor.pred.pass': '结束回合',
        'instructor.pred.purchase_tower': '夺取一座新塔',
        'instructor.purchase_tower_hint': "尝试点击屏幕底部的防御塔水晶区域，以占领一座新的 {colorName} 色防御塔！",
        'instructor.pred.mage_cast_spell': '施放法术',
        'instructor.pred.accept_activation': '接受效果',
        'instructor.pred.toggle_essence_mode': '进入获取精华模式',
        'instructor.pred.toggle_essence_mode_off': '退出获取精华模式',
        'instructor.pred.start_tower_purchase': '开始夺取一座塔',
        'instructor.pred.discard_stash': '将其燃烧以获取精华',
        'instructor.pred.discard_hand_for_essence': '将其弃掉以获取精华',
        'instructor.pred.astrid_blast': '使用英雄技能',
        'instructor.astrid_blast_hint': "尝试使用 [阿丝婷的箭矢按钮] 对对手造成必然伤害！为此，请将箭头从按钮拖放到对手的头像上。",
        'instructor.pred.default': '做出最佳行动',
        'instructor.flip_first': '在使用 [{elementName}] 前，请先将其翻转为 [{targetSideName}]（鼠标滚轮或箭头图标）。',
        'instructor.drag_to_prepare': '将 [{elementName}] 拖入空准备槽中。',
        'instructor.tryPlaying': '尝试打出 {cardName} 以 {prediction}。',
        'instructor.tryPlayingTarget': '尝试打出 {cardName} 以 {prediction}。为此，请将 {cardName} 拖放到目标上。',
        'instructor.tryClicking': '尝试点击 {elementName} 以 {prediction}。',
        'instructor.close': '关闭（此提示）',
        'instructor.turnOff': '关闭指导员',
        'instructor.drag_arrow_hint': '尝试通过按住卡片上的鼠标光标或手指，将箭头从卡片拖动到目标头像。',
        'instructor.title': '指导员的建议',
        'instructor.chooseLockedCardReturn': '看来你的锁定卡比卡槽多。选择 [{elementName}] 将其移回手牌。',
        'instructor.chooseBurglaryCard': '从对手手牌中选择 [{elementName}]。',
        'instructor.chooseColor': '选择 [{colorName}] 颜色。',
        'instructor.choosePurificationTarget': '选择 [{colorName}] 塔。',
        'ui.on': '开',
        'ui.off': '关',
        'admin.title': '指挥官档案 (管理员)',
        'admin.back': '返回',
        'admin.enterCode': '输入指挥官代码：',
        'admin.wrongCode': '代码错误。守卫已收到通知。',
        'admin.tie': '平衡 (平局)',
        'admin.zones': '区域管理',
        'admin.zone': '区域',
        'admin.pointsUpdated': '区域 {id} 分数已更新！',
        'admin.pointsFailed': '更新失败',
        'admin.siegeTitle': '区域 4 围攻',
        'admin.heroId': '英雄 ID:',
        'admin.startSiege': '开始围攻',
        'admin.siegeResetWarning': '* 开始事件将把计时器重置为 0。',
        'admin.siegeStarted': '以英雄 {id} 开始围攻！',
        'admin.siegeFailed': '启动失败',
        'admin.veriskMonitor': '维瑞斯监视器',
        'admin.weakest': '最弱:',
        'admin.strongest': '最强:',
        'admin.zone4Owner': '区域 4 所有者:',
        'admin.veriskCondition': '维瑞斯条件:',
        'admin.veriskHolders': '维瑞斯持有者:',
        'admin.conditionMet': '满足',
        'admin.conditionNotMet': '未满足',
        'admin.none': '无',
        'admin.neutral': '中立',
        'admin.userAccess': '用户权限',
        'admin.makeAdmin': '设为管理员',
        'admin.adminSuccess': '{user} 现在是管理员！',
        'admin.loading': '加载指挥官档案...',
        'admin.advanced': '高级用户管理',
        'admin.resetAll': '重置所有进度',
        'admin.deleteAll': '删除所有用户 (除自己)',
        'admin.resetUser': '重置进度',
        'admin.deleteUser': '删除用户',
        'admin.banUser': '封禁用户',
        'admin.unbanUser': '解封用户',
        'admin.confirmResetAll': '确定要重置所有玩家进度吗？此操作不可撤销。',
        'admin.confirmDeleteAll': '确定要删除所有用户吗？仅保留您的账号。',
        'admin.confirmAction': '确定要对用户 {user} 执行 {action} 吗？',
        'admin.actionSuccess': '操作成功！',
        'admin.userNotFound': '未找到用户。',
        'error.banned': '账户因可疑活动被阻止。',
        'hero.AXEL.name': '阿克塞尔',
        'hero.AXEL.desc': '未使用的彩色卡牌从准备槽返回手牌，并从相应颜色牌堆中添加一张副本。',
        'log.axelAbility': '{playerName} 的阿克塞尔技能复制了一张 {cardType} 卡！',

        // Notifications
        'notif.title': '通知',
        'notif.noNotifications': '暂无通知',
        'notif.markAllRead': '全部标为已读',
        'notif.clearAll': '清除全部',
        'notif.zoneCaptured': '区域 {zone} 已被 {faction} 占领！',
        'notif.heroBelongs': '英雄"{hero}"现在属于{faction}',
        'notif.factionCapturedTavern': '我们的阵营占领了酒馆(区域{zone})！英雄"{hero}"永远加入我们的收藏！',
        'notif.factionReinforcements': '援军到了！快去查看你的英雄收藏！英雄{hero}将帮助我们在世界地图上前进！',
        'notif.opalstoneGift': '输入Opalstone ID的礼物！新英雄"{hero}"加入你的收藏！',
        'notif.accountBlocked': '您的账户已被管理员封禁。',
        'notif.accountUpdate': '账户更新：{message}',
        'notif.global': '全局',
        'notif.faction': '阵营',
        'notif.individual': '个人',
    },
    ru: {
        // UI Labels
        'ui.title': 'Opalstone Kingdom',
        'ui.adminDashboard': 'Архив Командующего',
        'ui.fullscreen': 'На весь экран',
        'ui.exitFullscreen': 'Выйти из полноэкранного',
        'ui.nickname': 'Никнейм',
        'ui.vs': 'VS',
        'ui.round': 'Раунд',
        'ui.night': 'Ночь',
        'ui.alphaWarning': 'АЛЬФА ВЕРСИЯ - ВСЁ МОЖЕТ ИЗМЕНИТЬСЯ',
        'ui.lifetimeAverage': 'Среднее за всё время',

        // Phases
        'phase.transformTower': 'Преобразовать башню',
        'phase.yourResponse': 'Ваш ответ!',
        'phase.opponentResponding': 'Противник отвечает...',
        'phase.claimTower': 'Раунд {round}: Захватите башню',
        'phase.chooseHeroClass': 'Раунд {round}: Выберите героя и класс',
        'phase.waitingOtherPlayer': 'Ожидание выбора другого игрока...',
        'phase.opponentChoosingStash': 'Другой игрок всё ещё думает над картами...',
        'phase.setupComplete': 'Раунд {round}: Настройка завершена',
        'phase.acquireTower': 'Получить башню',
        'phase.choosePurification': 'Выберите цель очищения',
        'phase.choosePower': 'Раунд {round}: Выберите силу',
        'phase.resolveOverflow': 'Сброс лишних заблокированных карт',
        'phase.waiting': 'Ожидание...',
        'phase.prepare': 'Раунд {round}: Подготовка ({name} ходит первым ночью)',
        'phase.yourTurn': 'Ваш ход',
        'phase.opponentTurn': 'Ход противника',
        'phase.nightEnds': 'Ночь {round} завершается...',
        'phase.gameOver': 'Игра окончена',

        // Stats
        'ui.stats.winRate': 'Винрейт',
        'ui.stats.bestClass': 'Лучший класс',
        'ui.stats.worstClass': 'Худший класс',
        'ui.stats.games': 'Игры',

        // Card Descriptions
        'card.attack.desc': 'При использовании отнимает 1 единицу здоровья у выбранного противника за каждую красную карту.',
        'card.pushback.desc': 'Возвращает любую сыгранную карту цветной колоды (или карту из тайника Арсенала) обратно в руку противника. Эффект этой карты не срабатывает.',
        'card.heal.desc': 'Возвращает все карты болезней обратно в зеленую колоду и восстанавливает 1 единицу здоровья, вплоть до максимума.',
        'card.disease.desc': 'Каждый день здоровье игрока уменьшается на 1 за каждую карту болезни, которая у него есть.',
        'card.psy-search.desc': 'Возьмите две дополнительные карты из колоды.',
        'card.psy-block.desc': 'Блокирует любую сыгранную противником карту цветной колоды (или карту из тайника Артефактов) до следующей ночи. Заблокированная карта занимает слот подготовки.',
        'card.steal.desc': 'Случайным образом крадет одну карту из руки противника.',
        'card.double-cross.desc': 'Отменяет эффект любой карты цветной колоды. Обе карты удаляются из игры.',
        'card.shock.desc': 'Уменьшает количество карт, которые противники могут подготовить в следующем ходу, на 2. Этот эффект действует только один раз в следующей фазе дня.',
        'card.energize.desc': 'Увеличивает ваш лимит подготовки на 2 карты на следующий день (до абсолютного максимума 12). Эффект сбрасывается после фазы дня.',
        'card.hibernation.desc': 'Избегайте любого последующего урона в течение текущей ночи и следующего дня. Возьмите одну карту из цветных колод, но на следующий день не получайте карт из цветных колод.',
        'card.dispel.desc': 'Отменяет только сыгранные противником карты желтой, черной, зеленой и фиолетовой колод (а также карту из тайника Заклинаний). Обе карты сбрасываются в свои колоды.',
        'card.counterblast.desc': 'Отражает весь урон обратно в атакующего.',
        'card.planted-bomb.desc': 'Когда противник играет карту из тайника, наносит ему 5 урона.',
        'card.chromabow.desc': '4 очка атаки. Возьмите любую одну карту из цветных колод на ваш выбор.',
        'card.cursed-iron.desc': 'Уменьшает входящий урон на 1 до конца игры. После розыгрыша переходит в напоминания.',
        'card.discerning-eye.desc': 'Противник обязан открыть все карты, которые он подготовит в течение следующего дня.',
        'card.ale.desc': 'Увеличивает ваш лимит подготовки на 4 карты на следующий день.',
        'card.energy-sword.desc': '2 очка атаки. Увеличивает ваш лимит подготовки на 2 карты на следующий день.',
        'card.eyes-of-madness.desc': 'Увеличивает ваш лимит подготовки на 1 карту до конца игры. После розыгрыша переходит в напоминания.',
        'card.flying-scythe.desc': '2 очка атаки. Наносит 1 дополнительный урон за каждые 2 единицы здоровья, отсутствующие у противника до максимума.',
        'card.frost.desc': 'Противник получает эффект Гибернации до следующей ночи.',
        'card.inferno-gauntlet.desc': '4 очка атаки. Если эта атака уменьшает здоровье, цель случайно сбрасывает две карты.',
        'card.invincible.desc': 'Вы неуязвимы для любого урона в течение двух ночей и одного дня.',
        'card.larcendagger.desc': '3 очка атаки. Если эта атака уменьшает здоровье, крадет две карты у цели.',
        'card.life-charger.desc': 'Если здоровье закончится, пока эта карта подготовлена, немедленно восстановите его до максимума, заплатив Эссенцию.',
        'card.life-drain.desc': 'Противник теряет 2 единицы здоровья, а вы восстанавливаете такое же количество.',
        'card.madness-control.desc': 'Увеличивает ваш лимит подготовки на 4 карты до конца игры. После розыгрыша переходит в напоминания.',
        'card.natural-grip.desc': 'Противник теряет 2 единицы здоровья в день. Положите эту карту рядом с противником как напоминание. Можно вылечить с помощью Исцеления.',
        'card.body-upgrade.desc': 'Увеличивает макс. здоровье героя на 5 и добавляет 5 ХП.',
        'card.fortunes-favor.desc': 'Получайте одну дополнительную карту из колоды каждый день до конца игры. После розыгрыша переходит в напоминания.',
        'card.broken-secret.desc': 'Противник открывает свою руку. Если у него есть набор из трех одинаковых карт, заберите по одной карте из каждого набора.',
        'card.steal-tower.desc': 'Захватите любую башню на столе (не превышая лимит в одну башню за ночь).',
        'card.twilight-shift.desc': 'Пропустите следующую ночь.',
        'card.thunder-sprint.desc': 'Увеличивает ваш лимит подготовки на 5 на следующий день. Вы теряете 3 единицы здоровья.',
        'card.trembling.desc': 'Противник теряет здоровье, равное количеству карт, которые он подготовил на эту ночь.',
        'card.protector.desc': '2 очка защиты или 2 очка атаки. Восстанавливает 1 единицу здоровья.',
        'card.protector.chooseMode': 'Протектор: Выберите Режим',
        'card.protector.defenseLabel': 'Защита',
        'card.protector.attackLabel': 'Атака',
        'card.protector.defenseEffect': '+2 Щита',
        'card.protector.attackEffect': '2 Урона',
        'card.protector.passiveHeal': '+1 ОЗ восстанавливается автоматически',
        'card.arcane-boots.desc': 'Увеличивает ваш лимит подготовки на 2 карты на следующий день.',
        'card.card-cyclone.desc': 'Возьмите 3 карты.',
        'card.spikes.desc': 'При атаке наносит 1 урон атакующему.',
        'card.voodoo-doll.desc': 'Каждый раз, когда ваши карты наносят урон противнику, этот урон увеличивается на +1. Оставьте эту карту как напоминание.',
        'card.shadow-burglary.desc': 'Украдите 1 карту из руки противника.',
        'card.ancient-sword.desc': '5 очков атаки.',
        'card.ancient-shield.desc': '5 очков защиты.',
        'card.shimmering-shield.desc': '2 очка защиты. Стоит 5 Эссенции.',
        'card.steel-shield.desc': '2 очка защиты.',
        'card.the-sting.desc': '3 очка атаки.',
        'card.sword-of-revenge.desc': '8 очков атаки.',
        'card.paladins-hammer.desc': '3 очка атаки. Можно сыграть после паса.',
        'card.fireball.desc': '2 очка атаки.',
        'card.purification.desc': 'Захватить башню.',
        'card.seal-of-silence.desc': 'Запретить противнику использовать чары/артефакты в след. ходу.',

        'ui.endDay': 'Завершить день',
        'ui.pass': 'Пропустить',
        'ui.battleLog': 'Журнал боя',
        'ui.activeChain': 'Активная цепь',
        'ui.dropCounter': 'Поместите карту здесь',
        'ui.waiting': 'Ожидание',
        'ui.resolving': 'Разрешение',
        'ui.noActiveChains': 'Нет активных цепей',
        'ui.noEventsYet': 'Событий пока нет',
        'ui.accept': 'Принять',
        'ui.tapToClose': 'Нажмите, чтобы закрыть',
        'ui.waitingOpponent': 'Ожидание оппонента...',
        'ui.yourMove': 'Ваш ход',
        'ui.hand': 'Карты',
        'ui.essence': 'Эссенция',
        'ui.spells': 'Заклинания',
        'ui.preparation': 'Подготовка',
        'ui.reminders': 'Перенесено в напоминания после игры',
        'ui.shieldReaction': 'Ответный щит',
        'ui.playableAfterPass': 'Можно разыграть после паса',
        'ui.welcomeBack': 'С возвращением',
        'ui.joinKingdom': 'Вступить в Королевство',
        'ui.chooseYourFaction': 'Выберите фракцию',
        'ui.victory': 'Победа!',
        'ui.defeat': 'Поражение!',
        'ui.draw': 'Ничья!',
        'ui.victoryMsg': '{name} победил в дуэли! (+{fame} славы)',
        'ui.victorySolo': '{name} победил в дуэли!',
        'ui.defeatMsg': '{name} победил в дуэли!',
        'ui.drawMsg': 'Оба дуэлянта пали!',
        'ui.name': 'Имя',
        'ui.username': 'Имя пользователя',
        'ui.password': 'Пароль',
        'ui.opalstoneId': 'Опалстоун ID (НЕОБЯЗАТЕЛЬНО)',
        'ui.login': 'Войти',
        'ui.register': 'Регистрация',
        'ui.continue': 'Продолжить',
        'ui.nextGame': 'Следующая игра',
        'ui.confirm': 'Подтвердить',
        'ui.back': 'Назад',
        'ui.paused': 'Пауза',
        'ui.resume': 'Продолжить',
        'ui.options': 'Настройки',
        'ui.mainMenu': 'Главное меню',
        'ui.newGame': 'Новая игра',
        'ui.worldMap': 'Карта мира',
        'ui.myProfile': 'Мой профиль',
        'ui.quit': 'Выход',
        'ui.playAgain': 'Сыграть ещё',
        'ui.toMenu': 'Выйти в меню',
        'ui.opponent': 'Противник',
        'ui.selectGameMode': 'Выберите режим игры',
        'ui.withAI': 'С ИИ',
        'ui.multiplayer': 'Мультиплеер',
        'ui.aiBusters': 'Победители ИИ',
        'ui.noRecordsYet': 'Пока нет рекордов',
        'ui.createRoom': 'Создать комнату',
        'ui.joinRoom': 'Присоединиться',
        'ui.beginJourney': 'Начать путешествие',
        'ui.switchToLogin': 'Уже в Королевстве? Войти',
        'ui.switchToRegister': 'Впервые здесь? Создать аккаунт',
        'ui.newToKingdom': 'Впервые здесь? Создать аккаунт',
        'ui.alreadyHaveAccount': 'Уже в Королевстве? Войти',
        'ui.confirmFaction': 'Подтвердить выбор',
        'ui.selected': 'Выбрано',
        'ui.clickAgainToConfirm': 'Нажмите еще раз для подтверждения',
        'ui.selectAllegiance': 'Выбирайте сторону с умом, {username}',
        'error.nameLength': 'Имя должно быть не менее 2 символов',
        'error.passwordLength': 'Пароль должен быть не менее 6 символов',
        'error.opalFormat': 'Опалстоун ID должен состоять из 8 цифр',
        'error.opalInvalid': 'Опалстоун ID неверный или недоступный',
        'error.chooseFaction': 'Пожалуйста, выберите фракцию',
        'error.network': 'Ошибка сети (проверьте консоль)',
        'error.loginFailed': 'Ошибка входа',
        'error.registrationFailed': 'Ошибка регистрации',
        'ui.loadingAuth': 'Загрузка...',
        'ui.enterName': 'Введите ваше имя',
        'ui.enterPassword': 'Введите пароль',
        'ui.enterOpalId': '8-значный ID (Опционально)',
        'ui.enterRealm': 'Войти в мир',
        'ui.stashShop': 'Магазин колоды Stash',
        'ui.resurrectFromAsh': 'Воскрешение из пепла',
        'ui.selectCardCount': 'Выберите {count} карт(у)',
        'ui.stashOptions': 'Опции Stash',
        'ui.burnedPile': 'Сгоревшая стопка',
        'ui.confirmChoice': 'ПОДТВЕРДИТЬ ВЫБОР',
        'ui.faction': 'Фракция',
        'ui.controlPoints': 'Очки контроля',
        'ui.heroes': 'Герои',
        'ui.neutralZone': 'Нейтральная зона',
        'ui.noHeroBound': 'Нет героя, привязанного к этой зоне.',
        'ui.close': 'Закрыть',
        'ui.backToMenu': 'Назад в меню',
        'ui.level': 'Ур.',
        'ui.okId': 'OK ID',
        'ui.editProfile': 'Редактировать профиль',
        'ui.save': 'Сохранить',
        'ui.cancel': 'Отмена',
        'ui.honorProgress': 'Прогресс чести',
        'ui.famePoints': 'Очки славы',
        'ui.mostWanted': 'РАЗЫСКИВАЮТСЯ',
        'ui.justDefeatedAI': 'Только что победили ИИ',
        'ui.winRate': 'Процент побед',
        'ui.arcanePower': 'Тайная Сила',
        'ui.fameLevelHint': 'Уровень славы определяет какие эмоции можно использовать в анимированных слотах.',
        'ui.slot': 'Слот',
        'ui.selectEmote': 'Выберите эмоцию для слота',
        'ui.lvl': 'Ур.',
        'ui.heroesCollection': 'Коллекция',
        'ui.tab.heroes': 'Герои',
        'ui.tab.emotes': 'Эмоции',
        'ui.collected': 'Собрано',
        'ui.viewGallery': 'Посмотреть галерею',
        'ui.totalMatches': 'Всего матчей',
        'ui.viewHistory': 'Посмотреть историю',
        'ui.statistics': 'Статистика',
        'emote.PIECE': 'Мир',
        'emote.SMIRK': 'Ухмылка',
        'emote.ANGER': 'Ярость',
        'emote.SAD': 'Печаль',
        'emote.SHOCKED': 'Шок',
        'emote.THANKS': 'Почтение',
        'ui.stat.wins': 'Победы',
        'ui.stat.losses': 'Поражения',
        'ui.stat.winstreak': 'Лучшая серия',
        'ui.stat.totalDamage': 'Всего урона',
        'ui.matchHistory': 'История матчей',
        'ui.stats.heroStats': 'Статистика героев',
        'ui.stats.matchupHeatmap': 'Противостояния',
        'ui.stats.classEffectiveness': 'Эффективность классов',
        'ui.stats.heroVsClass': 'Герой vs Класс',

        'ui.stats.noData': 'Недостаточно данных',
        'ui.victoryScreen': 'ПОБЕДА',
        'ui.drawScreen': 'НИЧЬЯ',
        'ui.defeatScreen': 'ПОРАЖЕНИЕ',
        'ui.noMatchesYet': 'Матчи еще не записаны.',
        'ui.noHeroesYet': 'Герои еще не собраны.',
        'ui.winToCapture': 'Выигрывайте игры, чтобы захватывать героев!',
        'ui.faction.harmonized': 'Гармонизированные',
        'ui.faction.chaotic': 'Хаотичные',
        'ui.faction.untouched': 'Неприкосновенные',
        'ui.faction.none': 'Нет',
        'term.zone': 'Зона',
        'ui.waitingForPlayer': 'Ожидание игрока...',
        'ui.host': 'Хост',
        'ui.setupSelected': 'Выбор сделан',
        'ui.choosing': 'Выбирает...',
        'ui.ready': 'Готов',
        'ui.notReady': 'Не готов',
        'ui.lobby': 'Лобби',
        'ui.setNotReady': 'Отменить готовность',
        'ui.selectHeroAndClass': 'Выбрать героя и класс',
        'ui.readyUp': 'Готов!',
        'ui.startGame': 'Начать игру',
        'ui.leave': 'Выйти',
        'ui.setupYourChampion': 'Настройка вашего чемпиона',
        'ui.chooseHero': 'Выберите героя',
        'ui.chooseClass': 'Выберите класс',
        'ui.selectHeroAndClassPrompt': 'Выберите героя и класс, чтобы продолжить.',
        'ui.readyToLockIn': 'Вы готовы зафиксировать выбор.',
        'ui.choiceHiddenPrompt': 'Ваш выбор скрыт от оппонента до начала игры.',
        'ui.chooseHeroAndClass': 'Выберите героя и класс',
        'ui.classes': 'Классы',
        'ui.claimYourTower': 'Выберите вашу башню',
        'ui.towerChoiceDesc': 'Выберите цвет башни — она будет давать вам одну карту этого цвета каждый ход.',
        'ui.towerPurchaseDesc': 'Какую башню захватить? Сбросьте карты того же цвета. Соберите 5 башен для победы!',
        'ui.purificationDesc': 'Выберите башню для мгновенного захвата с помощью заклинания Очищения.',
        'ui.towerChangeDesc': 'Выберите новый цвет для вашей башни, чтобы изменить стратегию.',
        'ui.transformTower': 'Преобразовать башню',
        'ui.noColorCard': '(Нет карты {color})',
        'ui.isChoosingHeroClass': 'выбирает героя и класс.',
        'ui.isChoosingTower': 'выбирает начальную башню',
        'ui.notSet': 'Не установлено',
        'ui.loadingMap': 'Загрузка карты',
        'ui.lobbyChat': 'Чат лобби',
        'ui.sayHello': 'Поздоровайтесь с противником...',
        'ui.typeMessage': 'Введите сообщение...',
        'ui.send': 'Отправить',
        'multiplayer.createRoom': 'Создать комнату',
        'multiplayer.joinRoom': 'Присоединиться к комнате',
        'multiplayer.roomName': 'Название комнаты',
        'multiplayer.roomNamePlaceholder': 'Введите название...',
        'multiplayer.privateRoom': 'Приватная комната',
        'multiplayer.setPassword': 'Установить пароль',
        'multiplayer.passwordPlaceholder': 'Введите пароль...',
        'multiplayer.connecting': 'Подключение к серверу...',
        'multiplayer.disconnected': 'Отключено от сервера.',
        'multiplayer.noRooms': 'Нет доступных комнат',
        'multiplayer.noRoomsMatch': 'Комнаты не найдены',
        'multiplayer.refresh': 'Обновить',
        'multiplayer.back': 'Назад',
        'multiplayer.create': 'Создать комнату',
        'multiplayer.join': 'Войти',
        'multiplayer.cancel': 'Отмена',
        'multiplayer.passwordRequired': 'Требуется пароль',
        'multiplayer.availableRooms': 'Доступные комнаты',
        'multiplayer.host': 'Хост',
        'multiplayer.enterPasswordFor': 'Введите пароль для',
        'multiplayer.searchPlaceholder': 'Поиск по названию...',
        'multiplayer.confirmQuitMessage': 'Вы потеряете прогресс текущей игры. Вы уверены, что хотите вернуться в главное меню?',
        'multiplayer.confirmQuitAppMessage': 'Вы потеряете прогресс текущей игры. Вы уверены, что хотите выйти?',
        'multiplayer.abandonWarning': 'Покидая незавершенный матч вы потеряете очки славы (рейтинг). В Королевстве Опалстоун всегда можно перевернуть битву в свою пользу! Вы уверены что хотите покинуть игру?',
        'ui.technicalVictory': 'Техническая победа! Противник будет оштрафован за покинутый матч!',
        'ui.fameSummary': 'Заработано славы: +{fame}',
        'ui.fameSummaryNone': 'Слава не начислена (матч слишком короткий)',
        'term.match': 'Матч',
        'term.essence': 'Эссенция',
        'ui.chooseZoneToCapture': 'ВЫБЕРИТЕ ЗОНУ ДЛЯ ЗАХВАТА',
        'ui.idleHintDayTitle': 'День: Что вы можете сделать?',
        'ui.idleHintDayLine1': '1. Подготовьте или верните карты из слотов подготовки.',
        'ui.idleHintDayLine2': '2. Вращайте карты до или после подготовки.',
        'ui.idleHintDayLine3': '3. Нажмите кнопку Эссенции, чтобы войти в режим получения эссенции.',
        'ui.idleHintDayLine4': '',
        'ui.idleHintDayLine5': '',
        'ui.idleHintNightTitle': 'Ночь: Что вы можете сделать?',
        'ui.idleHintNightLine1': '1. Разыгрывайте карты из слотов подготовки в свой ход или в качестве ответа.',
        'ui.idleHintNightLine2': '2. Вращайте карты перед игрой, чтобы выбрать эффект.',
        'ui.idleHintNightLine3': '3. Нажмите кнопку Эссенции, чтобы войти в режим получения эссенции.',
        'ui.idleHintNightLine4': '4. Измените цвет ваших башен.',
        'ui.idleHintNightLine5': '5. Захватывайте новые башни.',
        'term.shieldReaction': 'Защитная реакция',
        'term.playableAfterPass': 'Можно играть после паса',
        'term.prepare-for-battle': 'Приготовьтесь к бою!',

        // General Terms
        'term.chaotic': 'Хаос',
        'term.harmonized': 'Равновесные',
        'term.untouched': 'Чистые',
        'term.neutral': 'Нейтральный',
        'term.opalstoneKingdom': 'Королевство Опалстоун',
        'term.warrior': 'Воин',
        'term.mage': 'Маг',
        'term.occultist': 'Оккультист',

        'class.WARRIOR.name': 'Воин',
        'class.MAGE.name': 'Маг',
        'class.OCCULTIST.name': 'Оккультист',

        'hero.NORIM.name': 'Норим',
        'hero.TERRIK.name': 'Террик',
        'hero.EVELION.name': 'Эвелион',
        'hero.CORIL.name': 'Корил',
        'hero.ASTRID.name': 'Астрид',
        'hero.FERRIM.name': 'Феррим',
        'hero.VERISK.name': 'Вериск',
        'hero.EROK_BURU.name': 'Эрок-Буру',
        'hero.VERG.name': 'Верг',
        'hero.NYRIX.name': 'Нирикс',
        'hero.SHANU.name': 'Шану',
        'hero.LORIAN.name': 'Лориан',
        'hero.GEMATA.name': 'Гемата',
        'hero.AXEL.desc': 'Неиспользованные цветные карты в слотах подготовки возвращаются в руку, и к ним добавляется копия из соответствующих цветных колод.',
        'log.axelAbility': 'Способность Акселя {playerName} копирует карту {cardType}!',
        'term.lorian': 'Лориан',

        'ui.acquireTower': 'Захват башни',
        'ui.choosePurificationTarget': 'Выберите цель очищения',
        'ui.cost': 'Стоимость: ',
        'ui.cardsSuffix': ' карты',
        'ui.stealFromOpponent': 'Кража',
        'ui.claimNeutral': 'Нейтральная',
        'color.red': 'КРАСНЫЕ',
        'color.green': 'ЗЕЛЕНЫЕ',
        'color.black': 'ЧЕРНЫЕ',
        'color.purple': 'ФИОЛЕТОВЫЕ',
        'color.pink': 'РОЗОВЫЕ',
        'color.yellow': 'ЖЕЛТЫЕ',
        'term.attack': 'Атака',
        'term.pushback': 'Отражение',
        'term.defense': 'Защита',
        'term.heal': 'Лечение',
        'term.disease': 'Болезнь',
        'term.steal': 'Стащить',
        'term.double-cross': 'Подстава',
        'term.shock': 'Шок',
        'term.energize': 'Зарядка',
        'term.hibernation': 'Спячка',
        'term.dispel': 'Рассеивание',
        'term.counterblast': 'Контрудар',
        'term.planted-bomb': 'Заложенная бомба',
        'term.chromabow': 'Хромалюк',
        'term.cursed-iron': 'Проклятое железо',
        'term.discerning-eye': 'Зоркий глаз',
        'term.ale': 'Эль',
        'term.energy-sword': 'Энергетический меч',
        'term.eyes-of-madness': 'Глаза безумия',
        'term.flying-scythe': 'Летучая коса',
        'term.frost': 'Мороз',
        'term.inferno-gauntlet': 'Инфернальная перчатка',
        'term.invincible': 'Неуязвимость',
        'term.larcendagger': 'Кинжал вора',
        'term.life-charger': 'Зарядник жизни',
        'term.life-drain': 'Похищение жизни',
        'term.madness-control': 'Контроль безумия',
        'term.natural-grip': 'Природная хватка',
        'term.body-upgrade': 'Улучшение тела',
        'term.fortunes-favor': 'Благосклонность удачи',
        'term.broken-secret': 'Раскрытый секрет',
        'term.steal-tower': 'Кража башни',
        'term.twilight-shift': 'Сумеречный сдвиг',
        'term.thunder-sprint': 'Громовой спринт',
        'term.trembling': 'Дрожь',
        'term.protector': 'Защитник',
        'term.arcane-boots': 'Арканные сапоги',
        'ui.specialEffect': 'Карта с особым эффектом',

        // Stash Deck Card Names
        'card.ancient-sword.name': 'Древний меч',
        'card.chromabow.name': 'Хромалук',
        'card.ancient-shield.name': 'Древний щит',
        'card.shimmering-shield.name': 'Мерцающий щит',
        'card.steel-shield.name': 'Стальной щит',
        'card.spikes.name': 'Шипы',
        'card.energy-sword.name': 'Энергетический меч',
        'card.flying-scythe.name': 'Летучая коса',
        'card.inferno-gauntlet.name': 'Инфернальная перчатка',
        'card.larcendagger.name': 'Кинжал вора',
        'card.the-sting.name': 'Жало',
        'card.sword-of-revenge.name': 'Меч мести',
        'card.paladins-hammer.name': 'Молот паладина',
        'card.planted-bomb.name': 'Заложенная бомба',
        'card.protector.name': 'Защитник',
        'card.cursed-iron.name': 'Проклятое железо',
        'card.fireball.name': 'Огненный шар',
        'card.purification.name': 'Очищение',
        'card.card-cyclone.name': 'Карточный циклон',
        'card.life-drain.name': 'Похищение жизни',
        'card.counterblast.name': 'Ответный взрыв',
        'card.eyes-of-madness.name': 'Очи безумия',
        'card.frost.name': 'Мороз',
        'card.invincible.name': 'Неуязвимость',
        'card.natural-grip.name': 'Природный захват',
        'card.shadow-burglary.name': 'Теневая кража',
        'card.twilight-shift.name': 'Сумеречный сдвиг',
        'card.thunder-sprint.name': 'Громовой спринт',
        'card.trembling.name': 'Трепет',
        'card.body-upgrade.name': 'Улучшение тела',
        'card.fortunes-favor.name': 'Благосклонность удачи',
        'card.discerning-eye.name': 'Проницательный глаз',
        'card.ale.name': 'Эль',
        'card.life-charger.name': 'Заряд жизни',
        'card.madness-control.name': 'Контроль безумия',
        'card.seal-of-silence.name': 'Печать молчания',
        'card.voodoo-doll.name': 'Кукла вуду',
        'card.arcane-boots.name': 'Магические сапоги',
        'card.broken-secret.name': 'Треснувший секрет',
        'hero.NORIM.desc': 'Каждая третья сожженная карта колоды Stash дает 8 эссенции вместо 4.',
        'hero.TERRIK.desc': 'Каждая подготовленная карта цветной колоды, сброшенная ночью, дает 3 эссенции.',
        'hero.EVELION.desc': 'Если оппонент теряет очки здоровья от ваших карт, вы восстанавливаете столько же здоровья.',
        'hero.CORIL.desc': 'Забирает в руку любую карту колоды Stash противника, отмененную его контр-действиями.',
        'hero.ASTRID.desc': 'При сбросе трех карт одного цвета за одну ночь, нанесите 2 ед. неизбежного урона выбранному оппоненту.',
        'hero.FERRIM.desc': 'При использовании колоды Stash вы можете просмотреть как саму колоду, так и стопку сброса карт Stash.',
        'hero.VERISK.desc': 'Копирует героя оппонента.',
        'hero.EROK_BURU.desc': 'Каждые 2 потерянных очка максимального здоровья дают один дополнительный слот подготовки на столе.',
        'hero.VERG.desc': 'Каждые 3 потерянных очка здоровья оппонента дают один дополнительный слот подготовки.',
        'hero.NYRIX.desc': 'Удваивает силу всех зеленых эффектов. «Исцеление» оппонента снимает только одну Болезнь вместо всех карточек-напоминаний о Болезни.',
        'hero.SHANU.desc': 'Восстанавливает полное максимальное здоровье при использовании эффекта Гибернации две ночи подряд.',
        'hero.LORIAN.desc': 'Способен менять свой класс в начале каждого нового хода',
        'hero.GEMATA.desc': 'При сжигании карт из колоды Stash эссенция не получается. Вместо этого возьмите три дополнительные карты из колоды раздачи.',
        'hero.TRIFLE.name': 'Трифл',
        'hero.TRIFLE.desc': 'При каждом сжигании карты Stash Deck все имеющиеся башни приносят +1 карту.',
        'class.WARRIOR.desc': 'Воин — мощный и гибкий класс. Первая карта Оружейной из колоды Stash, которую Воин подготавливает днем, увеличивает лимит подготовки на 1.',
        'class.MAGE.desc': 'Маг — класс, требующий величайшей мудрости. Маг может разыгрывать карты заклинаний Stash из своей руки ночью без подготовки. Разыгранные таким образом карты должны быть сброшены в колоду Stash. Также Маг может оставить 2 карты из 5, взятых из колоды Stash каждый день.',
        'class.OCCULTIST.desc': 'Оккультист силен на каждом этапе игры. Оккультист платит половину стоимости за карты Артефактов из колоды Stash.',

        // Log Messages
        'log.roundStart': 'Раунд {round} - Выберите вашу башню!',
        'log.towerChose': '{playerName} выбирает {towerColor} башню.',
        'log.towerClaimed': 'Очищение {playerName} захватывает нейтральную {targetColor} башню!',
        'log.towerStole': 'Очищение {playerName} крадет {targetColor} башню у {defenderName}!',
        'log.towerNoTarget': 'Очищение {playerName} не находит башен для захвата.',
        'log.towerFizzle': 'Очищение {playerName} не срабатывает - башня уже была захвачена этой ночью.',
        'log.stashExhausted': 'Колода Stash истощена! Фаза выбора карт пропущена.',
        'log.stashRefresh': 'Обновление вариантов Stash для {playerName}...',
        'log.silenced': '{playerName} в молчании и не может разыгрывать {cardType} карты этой ночью.',
        'log.lifeChargerBlocked': 'Заряд жизни {loserName} был заблокирован! {loserName} пал!',
        'log.victorious': '{playerName} побеждает!',
        'log.lifeChargerRestore': 'Заряд жизни {playerName} восстанавливает полное здоровье! Битва продолжается.',
        'log.immunityPrevented': 'Иммунитет {targetName} предотвращает {damage} ед. отраженного урона от Контрудара {sourceName}!',
        'log.counterblastReflect': 'Контрудар {sourceName} отражает {damage} ед. урона в {targetName}!',
        'log.lifeChargerAuto': 'Заряд жизни {playerName} активируется автоматически, чтобы предотвратить смерть!',
        'log.draw': 'Ничья!',
        'log.alreadyCaptured': '{playerName} уже захватил башню этой ночью.',
        'log.towerNotAvailable': 'Эта башня недоступна для захвата.',
        'log.notEnoughCards': 'У {playerName} недостаточно карт {towerColor}.',
        'log.towerTransform': '{playerName} превращает {oldColor} башню в {newColor} башню.',
        'log.cannotUseDirect': '{playerName} не может использовать {cardName} как прямое действие.',
        'log.shieldOnly': '{playerName} теперь может разыгрывать только карты щитов!',
        'log.lockedCard': '{playerName} пока не может использовать эту заблокированную карту!',
        'log.notEnoughEssence': 'У {playerName} недостаточно эссенции!',
        'log.payEssence': '{playerName} платит {essence} эссенции.',
        'log.attemptActivate': '{playerName} пытается активировать карту {cardType}!',
        'log.activateCard': '{playerName} активирует карту {cardType}!',
        'log.silencePinkSpell': '{playerName} может использовать Печать Молчания только против Розового или Заклинания.',
        'log.plantedBombChain': '{playerName} не может использовать Заложенную Бомбу без активной цепи.',
        'log.plantedBombStash': '{playerName} может использовать Заложенную Бомбу только против карт Колоды Stash.',
        'log.defenseActionOnly': '{playerName} может использовать {cardName} только против атакующего действия.',
        'log.succumbed': '{playerName} поддался ежедневному урону!',
        'log.drawFromTower': '{playerName} берет {towerColor} карту из своей башни.',
        'log.hibernatingTowers': '{playerName} в спячке и не берет карты из башен.',
        'log.hibernatingDeck': '{playerName} в спячке и не берет карты из колоды.',
        'log.twilightShift': 'Эффект Сумеречного сдвига: ночь пропущена, начинается дополнительный день.',
        'log.nightMarker': '--- Ночь {round} ---',
        'log.lorianChoice': '{playerName} должен выбрать класс на этот день.',
        'log.zonePoint': 'Очко победы присвоено Зоне {zoneId}. Контроль: {control}.',
        'log.neutral': 'Нейтральный',
        'log.pureHarmonized': 'Harmonized',
        'log.pureChaotic': 'Chaotic',
        'log.pureUntouched': 'Untouched',
        'log.doubleCrossInitial': 'Двойной крест нельзя использовать как начальную реакцию.',
        'log.invalidCounter': 'Неверная попытка контратаки.',
        'log.counterWith': '{playerName} контратакует картой {cardType}!',
        'log.heroClassSelected': '{playerName} выбрал героя {hero} и класс {playerClass}.',
        'log.lorianChoiceRefined': '{playerName} выбрал класс {playerClass} на этот день.',
        'log.oneMoreStash': '{playerName} может выбрать еще одну карту Stash.',
        'log.bodyUpgradeLog': '{playerName} улучшает свое тело, получая {value} макс. ОЗ!',
        'log.fortunesFavorLog': '{playerName} получает Благосклонность удачи и будет брать дополнительную карту каждый день!',
        'log.cursedIronLog': '{playerName} теперь защищен Проклятым железом, уменьшающим весь будущий урон на 1.',
        'log.eyesOfMadnessLog': 'Очи безумия {playerName} навсегда дают 1 слот подготовки!',
        'log.madnessControlLog': 'Контроль безумия {playerName} навсегда дает {value} слота(ов) подготовки!',
        'log.brokenSecretLog': 'Раскрытый секрет {playerName} открывает руку {defenderName}!',
        'log.stolenCardsLog': '{playerName} крадет {count} карт(ы) у {defenderName}!',
        'log.noSetsFoundLog': 'В руке {defenderName} не найдено наборов.',
        'log.invincibleLog': '{playerName} становится неуязвимым!',
        'log.fizzledLog': '{cardType} не срабатывает, так как первоначальная атака больше недействительна.',
        'log.invincibleAnywayLog': '{playerName} все равно становится неуязвимым!',
        'log.immuneLog': '{playerName} невосприимчив к отраженному урону!',
        'log.invincibleBlockLog': '{playerName} становится неуязвимым, блокируя атаку!',
        'log.bombImmuneLog': '{playerName} невосприимчив к Заложенной бомбе!',
        'log.bombCursedIronLog': 'Проклятое железо {playerName} уменьшает урон на {reduction}.',
        'log.bombExplodeLog': 'Заложенная бомба {bombOwner} взрывается, нанося {damage} урона {targetName}!',
        'log.protectorReactionLog': 'Защитник {playerName} дает {value} щита в ответ.',
        'log.protectorAttackLog': 'Защитник {playerName} атакует {targetName} на {damage} урона.',
        'log.protectorNegatedLog': 'Атака Защитника {playerName} на {targetName} сведена на нет иммунитетом.',
        'log.protectorDefenseLog': 'Защитник {playerName} дает {value} щита.',
        'log.protectorRestoreLog': '{playerName} восстанавливает {value} здоровья от Защитника.',
        'log.chromabowNegatedLog': 'Хромалюк {playerName} сведен на нет иммунитетом {defenderName}.',
        'log.chromabowDamageLog': 'Хромалюк {playerName} наносит {damage} урона {defenderName}.',
        'log.chromabowDrawLog': 'Хромалюк {playerName} дает карту из {color} колоды!',
        'log.slotOverflowLog': 'Заблокированная карта {cardType} игрока {playerName} возвращается в руку (переполнение слотов).',
        'log.lockedReturnSlot': 'Заблокированная карта {cardType} игрока {playerName} возвращается в руку (переполнение слотов).',
        'log.effectExpireDiscard': 'Эффект {cardType} игрока {playerName} истекает, и карта сбрасывается.',
        'log.effectExpireReturn': 'Эффект {cardType} игрока {playerName} истекает, и карта возвращается в руку.',
        'log.lockedReturn': 'Заблокированная карта {cardType} игрока {playerName} возвращается в руку.',
        'log.chooseLocked': '{playerName} должен выбрать, какие заблокированные карты вернуть (переполнение слотов).',
        'log.immuneDisease': '{playerName} невосприимчив к ежедневному урону.',
        'log.cursedIronReduce': 'Проклятое железо {playerName} уменьшает ежедневный урон на {damage}.',

        // Options Menu
        'ui.optionsTitle': 'Настройки',
        'ui.optionsMusicVolume': 'Громкость музыки',
        'ui.optionsSoundVolume': 'Звуковые эффекты',
        'ui.optionsEffects': 'Эффекты и анимации',
        'ui.optionsTooltips': 'Всплывающие подсказки',
        'ui.optionsActionHints': 'Подсказки действий',
        'ui.optionsInstructor': 'Описательный гайд (Инструктор)',
        'instructor.pred.prepare_card': 'подготовить её к ночи',
        'instructor.pred.attempt_activation': 'активировать её эффект',
        'instructor.pred.counter_activation': 'ответить на действие противника',
        'instructor.pred.end_day': 'завершить фазу подготовки',
        'instructor.pred.pass': 'передать ход',
        'instructor.pred.purchase_tower': 'захватить новую башню',
        'instructor.purchase_tower_hint': "Попробуйте нажать на область кристаллов башен в нижней части экрана, чтобы захватить новую башню цвета {colorName}!",
        'instructor.pred.mage_cast_spell': 'сотворить заклинание',
        'instructor.pred.accept_activation': 'принять эффекты',
        'instructor.pred.toggle_essence_mode': 'перейти в режим заработка эссенции',
        'instructor.pred.toggle_essence_mode_off': 'выйти из режима заработка эссенции',
        'instructor.pred.start_tower_purchase': 'начать захват башни',
        'instructor.pred.discard_stash': 'сжечь её за эссенцию',
        'instructor.pred.discard_hand_for_essence': 'сбросить её для получения эссенции',
        'instructor.pred.astrid_blast': 'использовать способность героя',
        'instructor.astrid_blast_hint': "Попробуйте использовать [Кнопку стрел Астрид], чтобы нанести противнику неизбежный урон! Для этого перетащите стрелу с кнопки на аватар противника.",
        'instructor.pred.default': 'сделать оптимальный ход',
        'instructor.flip_first': 'Прежде чем использовать карту [{elementName}], переверните её на сторону [{targetSideName}] (колесиком мышки или иконкой со стрелочками).',
        'instructor.drag_to_prepare': 'Подготовьте карту [{elementName}], перетянув её в пустой слот подготовки.',
        'instructor.tryPlaying': 'Попробуйте сыграть карту {cardName}, чтобы {prediction}.',
        'instructor.tryPlayingTarget': 'Попробуйте сыграть {cardName}, чтобы {prediction}. Для этого перетащите {cardName} на цель.',
        'instructor.tryClicking': 'Попробуйте нажать {elementName}, чтобы {prediction}.',
        'instructor.close': 'Закрыть (этот совет)',
        'instructor.turnOff': 'Выключить Инструктора',
        'instructor.drag_arrow_hint': 'Попробуйте протянуть стрелку от карты до аватара цели, зажав на самой карте курсор мыши или палец.',
        'instructor.title': 'Совет Инструктора',
        'instructor.chooseLockedCardReturn': 'Похоже, у вас больше заблокированных карт, чем слотов. Выберите [{elementName}], чтобы вернуть её в руку.',
        'instructor.chooseBurglaryCard': 'Выберите [{elementName}] из руки противника.',
        'instructor.chooseColor': 'Выберите цвет [{colorName}].',
        'instructor.choosePurificationTarget': 'Выберите башню цвета [{colorName}].',
        'ui.on': 'Вкл',
        'ui.off': 'Выкл',
        'admin.title': 'Архив Командующего (Admin)',
        'admin.back': 'Назад',
        'admin.enterCode': 'Введите секретный код Командующего:',
        'admin.wrongCode': 'Код неверен. Стража уведомлена.',
        'admin.tie': 'Равновесие (Ничья)',
        'admin.zones': 'Управление Зонами',
        'admin.zone': 'Зона',
        'admin.pointsUpdated': 'Очки Зоны {id} обновлены!',
        'admin.pointsFailed': 'Ошибка обновления',
        'admin.siegeTitle': 'Осада Зоны 4',
        'admin.heroId': 'ID Героя:',
        'admin.startSiege': 'Начать Осаду',
        'admin.siegeResetWarning': '* Старт события сбросит таймер на 0.',
        'admin.siegeStarted': 'Осада начата с героем {id}!',
        'admin.siegeFailed': 'Ошибка запуска',
        'admin.veriskMonitor': 'Монитор Verisk',
        'admin.weakest': 'Слабый:',
        'admin.strongest': 'Сильный:',
        'admin.zone4Owner': 'Владелец Зоны 4:',
        'admin.veriskCondition': 'Условие Verisk:',
        'admin.veriskHolders': 'Обладатели Verisk:',
        'admin.conditionMet': 'ВЫПОЛНЕНО',
        'admin.conditionNotMet': 'НЕ ВЫПОЛНЕНО',
        'admin.none': 'Нет',
        'admin.neutral': 'Нейтрал',
        'admin.userAccess': 'Права Доступа',
        'admin.makeAdmin': 'Сделать Админом',
        'admin.adminSuccess': '{user} теперь Админ!',
        'admin.loading': 'Загрузка Архива...',
        'admin.advanced': 'Расширенное управление',
        'ui.switchingRoom': 'Переключение комнаты...',
        'multiplayer.opponentDisconnectTimeout': 'Противник покинул игру (время ожидания истекло)',
        'multiplayer.hostDisconnected': 'Хост отключился от игры.',
        'error.lobbyFull': 'Комната заполнена',
        'error.lobbyNotFound': 'Комната не найдена',
        'error.lobbyUnavailable': 'Комната недоступна',
        'error.sessionAlreadyActive': 'Игровая сессия уже активна в другой вкладке',
        'error.banned': 'Аккаунт заблокирован за подозрительную активность.',

        // Notifications
        'notif.title': 'Уведомления',
        'notif.noNotifications': 'Нет уведомлений',
        'notif.markAllRead': 'Отметить все как прочитанное',
        'notif.clearAll': 'Очистить все',
        'notif.zoneCaptured': 'Зона {zone} была захвачена фракцией {faction}!',
        'notif.heroBelongs': 'Герой "{hero}" теперь принадлежит {faction}',
        'notif.factionCapturedTavern': 'Наша фракция захватила таверну (Зона {zone})! Герой "{hero}" теперь навсегда в нашей коллекции!',
        'notif.factionReinforcements': 'Нашей фракции пришла подмога! Проверь свою коллекцию героев! Герой {hero} поможет нам продвинуться на карте мира!',
        'notif.opalstoneGift': 'Подарок за ввод Opalstone ID! Новый герой "{hero}" в твоей коллекции!',
        'notif.accountBlocked': 'Ваш аккаунт был заблокирован администратором.',
        'notif.accountUpdate': 'Обновление аккаунта: {message}',
        'notif.global': 'Глобальное',
        'notif.faction': 'Фракция',
        'notif.individual': 'Личное',
    },
    uk: {
        // UI Labels
        'ui.title': 'Opalstone Kingdom',
        'ui.adminDashboard': 'Архів Командира',
        'ui.fullscreen': 'На весь екран',
        'ui.exitFullscreen': 'Вийти з повноекранного',
        'ui.nickname': 'Нікнейм',
        'ui.vs': 'VS',
        'ui.round': 'Раунд',
        'ui.night': 'Ніч',
        'ui.alphaWarning': 'АЛЬФА ВЕРСІЯ - ВСЕ МОЖЕ ЗМІНИТИСЯ',
        'ui.lifetimeAverage': 'Середнє за весь час',

        // Phases
        'phase.transformTower': 'Перетворити вежу',
        'phase.yourResponse': 'Ваша відповідь!',
        'phase.opponentResponding': 'Супротивник відповідає...',
        'phase.claimTower': 'Раунд {round}: Захопіть вежу',
        'phase.chooseHeroClass': 'Раунд {round}: Оберіть героя та клас',
        'phase.waitingOtherPlayer': 'Очікування вибору іншого гравця...',
        'phase.opponentChoosingStash': 'Інший гравець все ще думає над картами...',
        'phase.setupComplete': 'Раунд {round}: Налаштування завершено',
        'phase.acquireTower': 'Отримати вежу',
        'phase.choosePurification': 'Оберіть ціль очищення',
        'phase.choosePower': 'Раунд {round}: Оберіть силу',
        'phase.resolveOverflow': 'Скидання зайвих заблокованих карт',
        'phase.waiting': 'Очікування...',
        'phase.prepare': 'Раунд {round}: Підготовка ({name} ходить першим вночі)',
        'phase.yourTurn': 'Ваш хід',
        'phase.opponentTurn': 'Хід супротивника',
        'phase.nightEnds': 'Ніч {round} завершується...',
        'phase.gameOver': 'Гру закінчено',

        // Stats
        'ui.stats.winRate': 'Вінрейт',
        'ui.stats.bestClass': 'Найкращий клас',
        'ui.stats.worstClass': 'Найгірший клас',
        'ui.stats.games': 'Ігри',

        // Card Descriptions
        'card.attack.desc': 'При використанні забирає 1 одиницю здоров\'я у обраного супротивника за кожну червону карту.',
        'card.pushback.desc': 'Повертає будь-яку зіграну карту кольорової колоди (або карту зі схованки Арсеналу) назад у руку супротивника. Ефект цієї карти не спрацьовує.',
        'card.heal.desc': 'Повертає всі карти хвороб назад у зелену колоду та відновлює 1 одиницю здоров\'я, аж до максимума.',
        'card.disease.desc': 'Кожен день здоров\'я гравця зменшується на 1 за кожну карту хвороби, яку він має.',
        'card.psy-search.desc': 'Візьміть дві додаткові карти з колоди.',
        'card.psy-block.desc': 'Блокує будь-яку зіграну супротивником карту кольорової колоди (або карту зі схованки Артефактів) до наступної ночі. Заблокована карта займає слот підготовки.',
        'card.steal.desc': 'Випадковим чином краде одну карту з руки супротивника.',
        'card.double-cross.desc': 'Скасовує ефект будь-якої карти кольорової колоди. Обидві карти вилучаються з гри.',
        'card.shock.desc': 'Зменшує кількість карт, які супротивники можуть підготувати у наступному ході, на 2. Цей ефект діє лише один раз у наступній фазі дня.',
        'card.energize.desc': 'Збільшує ваш ліміт підготовки на 2 карти на наступний день (до абсолютного максимума 12). Ефект скидається після фази дня.',
        'card.hibernation.desc': 'Уникайте будь-якої подальшої шкоди протягом поточної ночі та наступного дня. Візьміть одну карту з кольорових колод, але наступного дня не отримуйте карт з кольорових колод.',
        'card.dispel.desc': 'Скасовує лише зіграні супротивником карти жовтої, чорної, зеленої та фіолетової колод (а також карту зі схованки Заклинань). Обидві карти скидаються у свої колоди.',
        'card.counterblast.desc': 'Відображає всю шкоду назад у нападника.',
        'card.planted-bomb.desc': 'Коли супротивник грає карту зі схованки, завдає йому 5 шкоди.',
        'card.chromabow.desc': '4 очки атаки. Візьміть будь-яку одну карту з кольорових колод на ваш вибір.',
        'card.cursed-iron.desc': 'Зменшує вхідну шкоду на 1 до кінця гри. Після розіграшу переходить у нагадування.',
        'card.discerning-eye.desc': 'Супротивник зобов\'язаний відкрити всі карти, які він підготує протягом наступного дня.',
        'card.ale.desc': 'Збільшує ваш ліміт підготовки на 4 карти на наступний день.',
        'card.energy-sword.desc': '2 очки атаки. Збільшує ваш ліміт підготовки на 2 карти на наступний день.',
        'card.eyes-of-madness.desc': 'Збільшує ваш ліміт підготовки на 1 карту до кінця гри. Після розіграшу переходить у нагадування.',
        'card.flying-scythe.desc': '2 очки атаки. Завдає 1 додаткової шкоди за кожні 2 одиниці здоров\'я, яких не вистачає супротивнику до максимума.',
        'card.frost.desc': 'Супротивник отримує ефект Гібернації до наступної ночі.',
        'card.inferno-gauntlet.desc': '4 очки атаки. Якщо ця атака зменшує здоров\'я, ціль випадково скидає дві карти.',
        'card.invincible.desc': 'Ви невразливі для будь-якої шкоди протягом двох ночей та одного дня.',
        'card.larcendagger.desc': '3 очки атаки. Якщо ця атака зменшує здоров\'я, краде дві карти у цілі.',
        'card.life-charger.desc': 'Якщо здоров\'я закінчиться, поки ця карта підготовлена, негайно відновите його до максимума, заплативши Есенцію.',
        'card.life-drain.desc': 'Супротивник втрачає 2 одиниці здоров\'я, а ви відновлюєте таку ж кількість.',
        'card.madness-control.desc': 'Збільшує ваш ліміт підготовки на 4 карти до кінця гри. Після розіграшу переходить у нагадування.',
        'card.natural-grip.desc': 'Супротивник втрачає 2 одиниці здоров\'я на день. Покладіть цю карту поруч із супротивником як нагадування. Можна вилікувати за допомогою Зцілення.',
        'card.body-upgrade.desc': 'Збільшує максимальне здоров\'я героя на 5 та додає 5 ОЗ.',
        'card.fortunes-favor.desc': 'Отримуйте одну додаткову карту з колоди кожен день до кінця гри. Переходить у нагадування після розіграшу.',
        'card.broken-secret.desc': 'Супротивник розкриває руку. Якщо у нього є набір з трьох однакових карт, візьміть по одній карті з кожного набору.',
        'card.steal-tower.desc': 'Захопіть будь-яку вежу на столі (не перевищує ліміт одна вежа за ніч).',
        'card.twilight-shift.desc': 'Пропустіть наступну Ніч.',
        'card.thunder-sprint.desc': 'Збільште свій ліміт підготовки на 5 на наступний день. Ви втрачаєте 3 одиниці здоров\'я.',
        'card.trembling.desc': 'Супротивник втрачає здоров\'я, що дорівнює кількості карт, які він підготував на цю ніч.',
        'card.protector.desc': '2 очки захисту або 2 очки атаки. Відновіть 1 одиницю здоров\'я.',
        'card.protector.chooseMode': 'Захисник: Оберіть Режим',
        'card.protector.defenseLabel': 'Захист',
        'card.protector.attackLabel': 'Атака',
        'card.protector.defenseEffect': '+2 Щита',
        'card.protector.attackEffect': '2 Шкоди',
        'card.protector.passiveHeal': '+1 ОЗ відновлюється автоматично',
        'card.arcane-boots.desc': 'Збільште свій ліміт підготовки на 2 карти на наступний день.',
        'card.card-cyclone.desc': 'Візьміть 3 карти.',
        'card.spikes.desc': 'При атаці завдайте 1 шкоду нападнику.',
        'card.voodoo-doll.desc': 'Кожного разу, коли ваші карти завдають шкоди супротивнику, ця шкода буде збільшена на +1. Залиште цю карту як нагадування.',
        'card.shadow-burglary.desc': 'Вкрадіть 1 карту з руки супротивника.',
        'card.ancient-sword.desc': '5 очок атаки.',
        'card.ancient-shield.desc': '5 очок захисту.',
        'card.shimmering-shield.desc': '2 очки захисту. Коштує 5 Есенції.',
        'card.steel-shield.desc': '2 очки захисту.',
        'card.the-sting.desc': '3 очки атаки.',
        'card.sword-of-revenge.desc': '8 очок атаки.',
        'card.paladins-hammer.desc': '3 очки атаки. Можна грати після пасу.',
        'card.fireball.desc': '2 очки атаки.',
        'card.purification.desc': 'Захопіть вежу.',
        'card.seal-of-silence.desc': 'Забороніть супротивнику використовувати заклинання/артефакти наступного ходу.',

        'ui.endDay': 'Завершити День',
        'ui.pass': 'Пас',
        'ui.battleLog': 'Журнал Бою',
        'ui.activeChain': 'Активний Ланцюг',
        'ui.dropCounter': 'Перетягніть Контр-карту Сюди',
        'ui.waiting': 'Очікування',
        'ui.resolving': 'Вирішення',
        'ui.noActiveChains': 'Немає активних ланцюгів',
        'ui.noEventsYet': 'Поки що немає подій',
        'ui.accept': 'Прийняти',
        'ui.tapToClose': 'Натисніть, щоб закрити',
        'ui.waitingOpponent': 'Очікування супротивника',
        'ui.yourMove': 'Ваш хід',
        'ui.hand': 'Рука',
        'ui.essence': 'Есенція',
        'ui.spells': 'Заклинання',
        'ui.preparation': 'Підготовка',
        'ui.reminders': 'Перенесено в нагадування після розіграшу',
        'ui.shieldReaction': 'Реакція щитом',
        'ui.playableAfterPass': 'Можна грати після Пасу',
        'ui.welcomeBack': 'З поверненням',
        'ui.joinKingdom': 'Приєднатися до Королівства',
        'ui.chooseYourFaction': 'Оберіть свою Фракцію',
        'ui.victory': 'Перемога!',
        'ui.defeat': 'Поразка!',
        'ui.draw': 'Нічия!',
        'ui.victoryMsg': '{name} виграв дуель! (+{fame} Слави)',
        'ui.victorySolo': '{name} виграв дуель!',
        'ui.defeatMsg': '{name} виграв дуель!',
        'ui.drawMsg': 'Обидва дуелянти впали!',
        'ui.name': 'Ім\'я',
        'ui.username': 'Ім\'я користувача',
        'ui.password': 'Пароль',
        'ui.opalstoneId': 'Opalstone ID (НЕОБОВ\'ЯЗКОВО)',
        'ui.login': 'Увійти',
        'ui.register': 'Реєстрація',
        'ui.continue': 'Продовжити',
        'ui.nextGame': 'Наступна гра',
        'ui.confirm': 'Підтвердити',
        'ui.back': 'Назад',
        'ui.paused': 'Пауза',
        'ui.resume': 'Продовжити',
        'ui.options': 'Налаштування',
        'ui.mainMenu': 'Головне меню',
        'ui.newGame': 'Нова гра',
        'ui.worldMap': 'Карта світу',
        'ui.myProfile': 'Мій профіль',
        'ui.quit': 'Вийти',
        'ui.playAgain': 'Зіграти ще',
        'ui.toMenu': 'Вийти в меню',

        'ui.opponent': 'Супротивник',
        'ui.selectGameMode': 'Оберіть режим гри',
        'ui.withAI': 'З ШІ',
        'ui.multiplayer': 'Мультиплеєр',
        'ui.aiBusters': 'Мисливці на ШІ',
        'ui.noRecordsYet': 'Поки немає записів',
        'ui.createRoom': 'Створити кімнату',
        'ui.joinRoom': 'Приєднатися',
        'ui.beginJourney': 'Почати подорож',
        'ui.switchToLogin': 'Вже учасник? Увійти',
        'ui.switchToRegister': 'Новачок у Королівстві? Створити акаунт',
        'ui.newToKingdom': 'Новачок у Королівстві? Створити акаунт',
        'ui.alreadyHaveAccount': 'Вже є акаунт? Увійти',
        'ui.confirmFaction': 'Підтвердити Фракцію',
        'ui.selected': 'Обрано',
        'ui.clickAgainToConfirm': 'Натисніть ще раз для підтвердження',
        'ui.selectAllegiance': 'Обирайте свою приналежність мудро, {username}',
        'error.nameLength': 'Ім\'я повинно містити не менше 2 символів',
        'error.passwordLength': 'Пароль повинен містити не менше 6 символів',
        'error.opalFormat': 'Opalstone ID повинен складатися з 8 цифр',
        'error.opalInvalid': 'Opalstone ID недійсний або недоступний',
        'error.chooseFaction': 'Будь ласка, оберіть фракцію',
        'error.network': 'Помилка мережі (перевірте консоль)',
        'error.loginFailed': 'Помилка входу',
        'error.registrationFailed': 'Помилка реєстрації',
        'ui.loadingAuth': 'Завантаження...',
        'ui.enterName': 'Введіть ваше ім\'я',
        'ui.enterPassword': 'Введіть пароль',
        'ui.enterOpalId': '8-значний ID (Опціонально)',
        'ui.enterRealm': 'Увійдіть у Світ',
        'ui.stashShop': 'Магазин Схованки',
        'ui.resurrectFromAsh': 'Воскреснути з Попелу',
        'ui.selectCardCount': 'Оберіть {count} карт(и)',
        'ui.stashOptions': 'Опції Схованки',
        'ui.burnedPile': 'Спалена Купа',
        'ui.confirmChoice': 'ПІДТВЕРДИТИ ВИБІР',
        'ui.faction': 'Фракція',
        'ui.controlPoints': 'Очки Контролю',
        'ui.heroes': 'Герої',
        'ui.neutralZone': 'Нейтральна Зона',
        'ui.noHeroBound': 'Жоден герой не прив\'язаний до цієї зони.',
        'ui.close': 'Закрити',
        'ui.backToMenu': 'Назад до меню',
        'ui.level': 'Рівень',
        'ui.okId': 'OK ID',
        'ui.editProfile': 'Редагувати профіль',
        'ui.save': 'Зберегти',
        'ui.cancel': 'Скасувати',
        'ui.famePoints': 'Очки Слави',
        'ui.mostWanted': 'НАЙБІЛЬШ РОЗШУКУВАНІ',
        'ui.justDefeatedAI': 'Щойно перемогли ШІ',
        'ui.winRate': 'Вінрейт',
        'ui.arcanePower': 'Містична Сила',
        'ui.fameLevelHint': 'Рівень Слави визначає, які емоції ви можете використовувати в анімованих слотах.',
        'ui.slot': 'Слот',
        'ui.selectEmote': 'Оберіть емоцію для слоту',
        'ui.heroesCollection': 'Колекція',
        'ui.tab.heroes': 'Герої',
        'ui.tab.emotes': 'Емоції',
        'ui.collected': 'Зібрано',
        'ui.viewGallery': 'Переглянути Галерею',
        'ui.totalMatches': 'Всього матчі',
        'ui.viewHistory': 'Історія',
        'ui.statistics': 'Статистика',
        'emote.PIECE': 'Мир',
        'emote.SMIRK': 'Усмішка',
        'emote.ANGER': 'Гнів',
        'emote.SAD': 'Сум',
        'emote.SHOCKED': 'Шок',
        'emote.THANKS': 'Повага',
        'ui.stat.wins': 'Перемоги',
        'ui.stat.losses': 'Поразки',
        'ui.stat.winstreak': 'Найк. серія перемог',
        'ui.stat.totalDamage': 'Всього завдано шкоди',
        'ui.matchHistory': 'Історія матчів',
        'ui.stats.heroStats': 'Статистика Героя',
        'ui.stats.matchupHeatmap': 'Теплова карта матчів',
        'ui.stats.classEffectiveness': 'Ефективність класу',
        'ui.stats.heroVsClass': 'Герой проти Класу',

        'ui.stats.noData': 'Недостатньо даних',
        'ui.victoryScreen': 'ПЕРЕМОГА',
        'ui.drawScreen': 'НІЧИЯ',
        'ui.defeatScreen': 'ПОРАЗКА',
        'ui.noMatchesYet': 'Матчів ще не записано.',
        'ui.noHeroesYet': 'Героїв ще не зібрано.',
        'ui.winToCapture': 'Перемагайте, щоб захопити героїв!',
        'ui.faction.harmonized': 'Гармонійний',
        'ui.faction.chaotic': 'Хаотичний',
        'ui.faction.untouched': 'Недоторканий',
        'ui.faction.none': 'Немає',
        'term.zone': 'Зона',
        'ui.waitingForPlayer': 'Очікування гравця...',
        'ui.host': 'Хост',
        'ui.setupSelected': 'Налаштування обрано',
        'ui.choosing': 'Вибір...',
        'ui.ready': 'Готовий',
        'ui.notReady': 'Не готовий',
        'ui.lobby': 'Лобі',
        'ui.setNotReady': 'Скасувати готовність',
        'ui.selectHeroAndClass': 'Оберіть Героя та Клас',
        'ui.readyUp': 'Готовий',
        'ui.startGame': 'Почати гру',
        'ui.leave': 'Вийти',
        'ui.setupYourChampion': 'Налаштуйте свого Чемпіона',
        'ui.chooseHero': 'Оберіть Героя',
        'ui.chooseClass': 'Оберіть Клас',
        'ui.selectHeroAndClassPrompt': 'Оберіть Героя та Клас, щоб продовжити.',
        'ui.readyToLockIn': 'Ви готові підтвердити.',
        'ui.choiceHiddenPrompt': 'Ваш вибір прихований від супротивника до початку гри.',
        'ui.chooseHeroAndClass': 'Оберіть Героя та Клас',
        'ui.classes': 'Класи',
        'ui.claimYourTower': 'Захопіть свою вежу',
        'ui.towerChoiceDesc': 'Оберіть колір своєї вежі - вона даватиме вам одну карту того ж кольору за хід.',
        'ui.towerPurchaseDesc': 'Яку вежу захопити? Скиньте карти того ж кольору. Зберіть 5 веж, щоб перемогти!',
        'ui.purificationDesc': 'Оберіть вежу, щоб захопити її миттєво за допомогою заклинання Очищення.',
        'ui.towerChangeDesc': 'Оберіть новий колір для своєї вежі, щоб змінити стратегію.',
        'ui.transformTower': 'Перетворити вежу',
        'ui.noColorCard': '(Немає {color} карти)',
        'ui.isChoosingHeroClass': 'обирає Героя та Клас.',
        'ui.isChoosingTower': 'обирає стартову вежу',
        'ui.notSet': 'Не встановлено',
        'ui.loadingMap': 'Завантаження карти',
        'ui.lobbyChat': 'Чат Лобі',
        'ui.sayHello': 'Привітайтеся з супротивником...',
        'ui.typeMessage': 'Введіть повідомлення...',
        'ui.send': 'Надіслати',
        'multiplayer.createRoom': 'Створити кімнату',
        'multiplayer.joinRoom': 'Приєднатися до кімнати',
        'multiplayer.roomName': 'Назва кімнати',
        'multiplayer.roomNamePlaceholder': 'Введіть назву кімнати...',
        'multiplayer.privateRoom': 'Приватна кімната',
        'multiplayer.setPassword': 'Встановіть пароль для кімнати',
        'multiplayer.passwordPlaceholder': 'Введіть пароль...',
        'multiplayer.connecting': 'Підключення до сервера...',
        'multiplayer.disconnected': 'Відключено від сервера.',
        'multiplayer.noRooms': 'Немає доступних кімнат',
        'multiplayer.noRoomsMatch': 'Жодна кімната не відповідає пошуку',
        'multiplayer.refresh': 'Оновити',
        'multiplayer.back': 'Назад',
        'multiplayer.create': 'Створити',
        'multiplayer.join': 'Приєднатися',
        'multiplayer.cancel': 'Скасувати',
        'multiplayer.passwordRequired': 'Потрібен пароль',
        'multiplayer.availableRooms': 'Доступні кімнати',
        'multiplayer.host': 'Хост',
        'multiplayer.enterPasswordFor': 'Введіть пароль для',
        'multiplayer.searchPlaceholder': 'Пошук за назвою кімнати...',
        'multiplayer.confirmQuitMessage': 'Ви втратите поточний прогрес гри. Ви впевнені, що хочете повернутися до головного меню?',
        'multiplayer.confirmQuitAppMessage': 'Ви втратите поточний прогрес гри. Ви впевнені, що хочете вийти?',
        'multiplayer.abandonWarning': 'Покидаючи незавершений матч ви втратите очки слави (рейтинг). В Королівстві Опалстоун завжди можна перевернути битву на свою користь! Ви впевнені що хочете покинути гру?',
        'ui.technicalVictory': 'Технічна перемога! Суперника буде оштрафовано за покинутий матч!',
        'ui.fameSummary': 'Зароблено слави: +{fame}',
        'ui.fameSummaryNone': 'Слави не нараховано (матч занадто короткий)',
        'ui.areYouSure': 'Ви впевнені?',
        'ui.switchingRoom': 'Перемикання кімнати...',
        'multiplayer.opponentDisconnectTimeout': 'Суперник покинув гру (час очікування вичерпано)',
        'multiplayer.hostDisconnected': 'Хост відключився від гри.',
        'error.lobbyFull': 'Лобі заповнене',
        'error.lobbyNotFound': 'Лобі не знайдено',
        'error.lobbyUnavailable': 'Кімната недоступна',
        'error.sessionAlreadyActive': 'Ігрова сесія вже активна в іншій вкладці',
        'term.match': 'Матч',
        'term.essence': 'Есенція',
        'ui.chooseZoneToCapture': 'ОБЕРІТЬ ЗОНУ ДЛЯ ЗАХОПЛЕННЯ',
        'ui.idleHintDayTitle': 'День: Що ви можете робити?',
        'ui.idleHintDayLine1': '1. Підготувати або повернути карти зі слотів підготовки.',
        'ui.idleHintDayLine2': '2. Обертати карти до або після підготовки.',
        'ui.idleHintDayLine3': '3. Натиснути кнопку Есенції, щоб увійти в режим отримання Есенції.',
        'ui.idleHintDayLine4': '',
        'ui.idleHintDayLine5': '',
        'ui.idleHintNightTitle': 'Ніч: Що ви можете робити?',
        'ui.idleHintNightLine1': '1. Грати карти зі слотів підготовки у свій хід або як відповідь.',
        'ui.idleHintNightLine2': '2. Обертати карти перед грою, щоб обрати ефект.',
        'ui.idleHintNightLine3': '3. Натиснути кнопку Есенції, щоб увійти в режим отримання Есенції.',
        'ui.idleHintNightLine4': '4. Змінити колір своїх веж.',
        'ui.idleHintNightLine5': '5. Захопити нові вежі.',
        'term.shieldReaction': 'Реакція щитом',
        'term.playableAfterPass': 'Можна грати після Пасу',
        'term.prepare-for-battle': 'Готуйтеся до бою!',

        // General Terms
        'term.chaotic': 'Хаотичний',
        'term.harmonized': 'Гармонійний',
        'term.untouched': 'Недоторканий',
        'term.neutral': 'Нейтральний',
        'term.opalstoneKingdom': 'Opalstone Kingdom',
        'term.warrior': 'Воїн',
        'term.mage': 'Маг',
        'term.occultist': 'Окультист',

        'class.WARRIOR.name': 'Воїн',
        'class.WARRIOR.desc': 'Воїн — потужний і гнучкий клас. Перша карта зі схованки Арсеналу, яку Воїн готує протягом дня, збільшить ліміт підготовки на 1.',
        'class.MAGE.name': 'Маг',
        'class.MAGE.desc': 'Маг — це клас, що вимагає найбільшої мудрості. Маг може грати карти зі схованки Заклинань прямо з руки вночі без підготовки. Зіграні таким чином карти заклинань повинні бути скинуті в колоду схованки. Також Маг здатний зберегти 2 карти з 5 карт, взятих зі схованки щодня.',
        'class.OCCULTIST.name': 'Окультист',
        'class.OCCULTIST.desc': 'Окультист сильний на кожному етапі гри. Окультист платить половину вартості за карти зі схованки Артефактів.',

        'hero.NORIM.name': 'Норім',
        'hero.NORIM.desc': 'Кожна третя спалена карта зі схованки дає 8 Есенції замість 4.',
        'hero.TERRIK.name': 'Террік',
        'hero.TERRIK.desc': 'Кожна підготовлена ​​карта кольорової колоди, яка скидається вночі, дає 3 Есенції за карту.',
        'hero.EVELION.name': 'Евеліон',
        'hero.EVELION.desc': 'Якщо супротивник втрачає здоров\'я від ваших карт, ви відновлюєте таку ж кількість здоров\'я.',
        'hero.CORIL.name': 'Коріл',
        'hero.CORIL.desc': 'Забирає в руку будь-яку карту схованки супротивника, скасовану його контрдіями.',
        'hero.ASTRID.name': 'Астрід',
        'hero.ASTRID.desc': 'При скиданні трьох карт одного кольору за одну ніч, завдає 2 неминучої шкоди обраному супротивнику.',
        'hero.FERRIM.name': 'Феррім',
        'hero.FERRIM.desc': 'При використанні схованки, ви можете перевіряти або карти схованки, або спалену купу карт схованки.',
        'hero.VERISK.name': 'Веріск',
        'hero.VERISK.desc': "Копіювання героя супротивника.",
        'hero.EROK_BURU.name': 'Ерок-Буру',
        'hero.EROK_BURU.desc': 'Кожні 2 очки, втрачені від максимального здоров\'я, дають один додатковий слот підготовки на столі.',
        'hero.VERG.name': 'Верг',
        'hero.VERG.desc': 'Кожні 3 очки, втрачені від максимального здоров\'я супротивника, дають один додатковий слот підготовки.',
        'hero.NYRIX.name': 'Нірікс',
        'hero.NYRIX.desc': 'Подвоює силу всіх Зелених Ефектів. «Зцілення» супротивників знімає лише одну Хворобу замість усіх нагадувань про Хворобу.',
        'hero.SHANU.name': 'Шану',
        'hero.SHANU.desc': 'Відновлює повне максимальне здоров\'я при використанні ефекту Гібернації дві ночі поспіль.',
        'hero.LORIAN.name': 'Лоріан',
        'hero.LORIAN.desc': 'Здатний змінювати свій клас на початку кожного нового ходу',
        'hero.GEMATA.name': 'Гемата',
        'hero.GEMATA.desc': 'При спалюванні карт зі схованки Есенція не отримується. Замість цього візьміть три додаткові карти з колоди.',
        'hero.TRIFLE.name': 'Трайфл',
        'hero.TRIFLE.desc': 'При спалюванні карти зі схованки беріть по одній карті з кольорових колод за кожну вежу, якою ви володієте.',
        'hero.AXEL.name': 'Аксель',
        'hero.AXEL.desc': 'Невикористані кольорові карти в слотах підготовки повертаються в руку, і додається їх копія з відповідних кольорових колод.',
        'log.axelAbility': 'Здібність Акселя {playerName} копіює карту {cardType}!',
        'term.lorian': 'Лоріан',

        'ui.acquireTower': 'Отримати вежу',
        'ui.choosePurificationTarget': 'Оберіть ціль очищення',
        'ui.cost': 'Вартість: ',
        'ui.cardsSuffix': ' карт',
        'ui.stealFromOpponent': 'Вкрадення',
        'ui.claimNeutral': 'Нейтральна',
        'color.red': 'ЧЕРВОНИЙ',
        'color.green': 'ЗЕЛЕНИЙ',
        'color.black': 'ЧОРНИЙ',
        'color.purple': 'ФІОЛЕТОВИЙ',
        'color.pink': 'РОЖЕВИЙ',
        'color.yellow': 'ЖОВТИЙ',
        'term.attack': 'Атака',
        'term.pushback': 'Відштовх.',
        'term.defense': 'Захист',
        'term.heal': 'Зцілення',
        'term.disease': 'Хвороба',
        'term.psy-search': 'Псі-пошук',
        'term.psy-block': 'Псі-блок',
        'term.steal': 'Поцупити',
        'term.double-cross': 'Підстава',
        'term.shock': 'Шок',
        'term.energize': 'Заряд',
        'term.hibernation': 'Гібернація',
        'term.dispel': 'Розсіювання',
        'term.counterblast': 'Контрудар',
        'term.planted-bomb': 'Закладена бомба',
        'term.chromabow': 'Хромалук',
        'term.cursed-iron': 'Прокляте залізо',
        'term.discerning-eye': 'Проникливе око',
        'term.ale': 'Ель',
        'term.energy-sword': 'Енергомеч',
        'term.eyes-of-madness': 'Очі божевілля',
        'term.flying-scythe': 'Летюча коса',
        'term.frost': 'Мороз',
        'term.inferno-gauntlet.desc': 'Пекельна рукавичка',
        'term.invincible': 'Невразливий',
        'term.larcendagger': 'Кинджал злодія',
        'term.life-charger': 'Заряд життя',
        'term.life-drain': 'Викрадення життя',
        'term.madness-control': 'Контроль божевілля',
        'term.natural-grip': 'Природна хватка',
        'term.body-upgrade': 'Покращення тіла',
        'term.fortunes-favor': 'Прихильність долі',
        'term.broken-secret': 'Зламаний секрет',
        'term.steal-tower': 'Викрадення вежі',
        'term.twilight-shift': 'Сутінковий зсув',
        'term.thunder-sprint': 'Громовий ривок',
        'term.trembling.desc': 'Требіння',
        'term.protector': 'Захисник',
        'term.arcane-boots': 'Арканні чоботи',
        'term.red': 'Червоний',
        'term.pink': 'Рожевий',
        'term.green': 'Зелений',
        'term.black': 'Чорний',
        'term.purple': 'Фіолетовий',
        'term.yellow': 'Жовтий',
        'ui.specialEffect': 'Карта спец. ефекту',

        // Stash Deck Cards
        'card.planted-bomb.name': 'Закладена бомба',
        'card.protector.name': 'Захисник',
        'card.steel-shield.name': 'Сталевий щит',
        'card.sword-of-revenge.name': 'Меч помсти',
        'card.ancient-sword.name': 'Стародавній меч',
        'card.inferno-gauntlet.name': 'Пекельна рукавичка',
        'card.cursed-iron.name': 'Прокляте залізо',
        'card.natural-grip.name': 'Природна хватка',
        'card.ancient-shield.name': 'Стародавній щит',
        'card.arcane-boots.name': 'Арканні чоботи',
        'card.twilight-shift.name': 'Сутінковий зсув',
        'card.trembling.name': 'Тремор',
        'card.shadow-burglary.name': 'Тіньова крадіжка',
        'card.invincible.name': 'Невразливий',
        'card.eyes-of-madness.name': 'Очі божевілля',
        'card.purification.name': 'Очищення',
        'card.fireball.name': 'Вогняна куля',
        'card.life-drain.name': 'Викрадення життя',
        'card.counterblast.name': 'Контрудар',
        'card.card-cyclone.name': 'Картковий циклон',
        'card.paladins-hammer.name': 'Молот паладина',
        'card.body-upgrade.name': 'Покращення тіла',
        'card.fortunes-favor.name': 'Прихильність долі',
        'card.shimmering-shield.name': 'Мерехтливий щит',
        'card.discerning-eye.name': 'Проникливе око',
        'card.ale.name': 'Ель',
        'card.energy-sword.name': 'Енергомеч',
        'card.flying-scythe.name': 'Летюча коса',
        'card.frost.name': 'Мороз',
        'card.life-charger.name': 'Заряд життя',
        'card.madness-control.name': 'Контроль божевілля',
        'card.spikes.name': 'Шипи',
        'card.thunder-sprint.name': 'Громовий ривок',
        'card.seal-of-silence.name': 'Печать тиші',
        'card.voodoo-doll.name': 'Лялька Вуду',
        'card.chromabow.name': 'Хромалук',
        'card.the-sting.name': 'Жало',
        'card.broken-secret.name': 'Зламаний секрет',
        'card.larcendagger.name': 'Кинджал злодія',

        // Log Messages
        'log.roundStart': 'Раунд {round} - Оберіть вашу вежу!',
        'log.towerChose': '{playerName} обрав {towerColor} вежу.',
        'log.towerClaimed': 'Очищення {playerName} захоплює нейтральну {targetColor} вежу!',
        'log.towerStole': 'Очищення {playerName} краде {targetColor} вежу у {defenderName}!',
        'log.towerNoTarget': 'Очищення {playerName} не знаходить веж для захоплення.',
        'log.towerFizzle': 'Очищення {playerName} розсіюється - вежа вже захоплена цієї ночі.',
        'log.stashExhausted': 'Схованка вичерпана! Фаза вибору карт пропущена.',
        'log.stashRefresh': 'Оновлення варіантів схованки для {playerName}...',
        'log.silenced': '{playerName} змушений мовчати і не може грати {cardType} карти цієї ночі.',
        'log.lifeChargerBlocked': 'Заряд життя {loserName} був заблокований! {loserName} впав!',
        'log.victorious': '{playerName} перемагає!',
        'log.lifeChargerRestore': 'Заряд життя {playerName} відновлює повне здоров\'я! Битва триває.',
        'log.immunityPrevented': 'Імунітет {targetName} запобігає {damage} відображеної шкоди від Контрудару {sourceName}!',
        'log.counterblastReflect': 'Контрудар {sourceName} відображає {damage} шкоди у {targetName}!',
        'log.lifeChargerAuto': 'Заряд життя {playerName} активується автоматично, щоб запобігти смерті!',
        'log.draw': 'Нічия!',
        'log.alreadyCaptured': '{playerName} вже захопив вежу цієї ночі.',
        'log.towerNotAvailable': 'Цю вежу неможливо захопити.',
        'log.notEnoughCards': '{playerName} не має достатньо {towerColor} карт.',
        'log.towerTransform': '{playerName} перетворює {oldColor} вежу на {newColor} вежу.',
        'log.cannotUseDirect': '{playerName} не може використовувати {cardName} як пряму дію.',
        'log.shieldOnly': '{playerName} може грати лише карти щита зараз!',
        'log.lockedCard': '{playerName} ще не може використовувати цю заблоковану карту!',
        'log.notEnoughEssence': '{playerName} недостатньо есенції!',
        'log.payEssence': '{playerName} платить {essence} есенції.',
        'log.attemptActivate': '{playerName} намагається активувати {cardType} карту!',
        'log.activateCard': '{playerName} активує {cardType} карту!',
        'log.silencePinkSpell': '{playerName} може використовувати Печать тиші лише проти Рожевої або Початкової дії заклинання.',
        'log.plantedBombChain': '{playerName} не може використовувати Закладену бомбу без активного ланцюга.',
        'log.plantedBombStash': '{playerName} може використовувати Закладену бомбу лише проти карт зі Схованки.',
        'log.defenseActionOnly': '{playerName} може використовувати {cardName} лише проти дії, що завдає шкоди.',
        'log.succumbed': '{playerName} піддався щоденній шкоді!',
        'log.drawFromTower': '{playerName} взяв {towerColor} карту зі своєї вежі.',
        'log.hibernatingTowers': '{playerName} в гібернації і не бере карти з веж.',
        'log.hibernatingDeck': '{playerName} в гібернації і не бере карти з колоди.',
        'log.twilightShift': 'Ефект Сутінкового зсуву: ніч пропущена, починається додатковий день.',
        'log.nightMarker': '--- Ніч {round} ---',
        'log.lorianChoice': '{playerName} повинен обрати клас для дня.',
        'log.zonePoint': 'Очко перемоги призначено Зоні {zoneId}. Контроль: {control}.',
        'log.neutral': 'Нейтральний',
        'log.pureHarmonized': 'Гармонійний',
        'log.pureChaotic': 'Хаотичний',
        'log.pureUntouched': 'Недоторканий',
        'log.doubleCrossInitial': 'Подвійна гра не може бути використана як початкова реакція.',
        'log.invalidCounter': 'Недійсне спроба контрдії.',
        'log.counterWith': '{playerName} відповідає {cardType}!',
        'log.heroClassSelected': '{playerName} обрав Героя {hero} та Клас {playerClass}.',
        'log.lorianChoiceRefined': '{playerName} обрав клас {playerClass} для дня.',
        'log.oneMoreStash': '{playerName} може обрати ще одну карту зі Схованки.',
        'log.bodyUpgradeLog': '{playerName} покращує своє тіло, отримуючи {value} макс. здоров\'я!',
        'log.fortunesFavorLog': '{playerName} отримує Прихильність долі та братиме додаткову карту щодня!',
        'log.cursedIronLog': '{playerName} тепер захищений Проклятим залізом, зменшуючи всю майбутню шкоду на 1.',
        'log.eyesOfMadnessLog': 'Очі божевілля {playerName} назавжди дають 1 слот підготовки!',
        'log.madnessControlLog': 'Контроль божевілля {playerName} назавжди дає {value} слотів підготовки!',
        'log.brokenSecretLog': 'Зламаний секрет {playerName} розкриває руку {defenderName}!',
        'log.stolenCardsLog': '{playerName} краде {count} карт(и) у {defenderName}!',
        'log.noSetsFoundLog': 'У руці {defenderName} не знайдено наборів.',
        'log.invincibleLog': '{playerName} стає Невразливим!',
        'log.fizzledLog': '{cardType} розсіюється, оскільки оригінальна атака більше не є дійсною.',
        'log.invincibleAnywayLog': '{playerName} все одно стає Невразливим!',
        'log.immuneLog': '{playerName} має імунітет до відображеної шкоди!',
        'log.invincibleBlockLog': '{playerName} стає Невразливим, блокуючи атаку!',
        'log.bombImmuneLog': '{playerName} має імунітет до Закладеної бомби!',
        'log.bombCursedIronLog': 'Прокляте залізо {playerName} зменшує шкоду на {reduction}.',
        'log.bombExplodeLog': 'Закладена бомба {playerName} вибухає, завдаючи {damage} шкоди {targetName}!',
        'log.protectorReactionLog': 'Захисник {playerName} дає {value} щита як реакцію.',
        'log.protectorAttackLog': 'Захисник {playerName} атакує {targetName} на {damage} шкоди.',
        'log.protectorNegatedLog': 'Атака Захисника {playerName} на {targetName} скасована імунітетом.',
        'log.protectorDefenseLog': 'Захисник {playerName} дає {value} щита.',
        'log.protectorRestoreLog': '{playerName} відновлює {value} здоров\'я від Захисника.',
        'log.chromabowNegatedLog': 'Хромалук {playerName} скасований імунітетом {defenderName}.',
        'log.chromabowDamageLog': 'Хромалук {playerName} завдає {damage} шкоди {defenderName}.',
        'log.chromabowDrawLog': 'Хромалук {playerName} дає карту з {color} колоди!',
        'log.slotOverflowLog': 'Заблокована {cardType} {playerName} повертається в руку (переповнення слотів).',
        'log.lockedReturnSlot': 'Заблокована {cardType} {playerName} повертається в руку (переповнення слотів).',
        'log.effectExpireDiscard': 'Ефект {cardType} {playerName} закінчується і скидається.',
        'log.effectExpireReturn': 'Ефект {cardType} {playerName} закінчується і повертається в руку.',
        'log.lockedReturn': 'Заблокована {cardType} {playerName} повертається в руку.',
        'log.chooseLocked': '{playerName} повинен обрати, які заблоковані карти повернути (переповнення слотів).',
        'log.immuneDisease': '{playerName} має імунітет до щоденної шкоди.',
        'log.cursedIronReduce': 'Прокляте залізо {playerName} зменшує щоденну шкоду на {damage}.',

        // Options Menu
        'ui.optionsTitle': 'Налаштування',
        'ui.optionsMusicVolume': 'Гучність музики',
        'ui.optionsSoundVolume': 'Звукові ефекти',
        'ui.optionsEffects': 'Ефекти та Анімації',
        'ui.optionsTooltips': 'Підказки',
        'ui.optionsActionHints': 'Підказки дій',
        'ui.optionsInstructor': 'Описовий гайд (Інструктор)',
        'instructor.pred.prepare_card': 'підготувати її до ночі',
        'instructor.pred.attempt_activation': 'активувати її ефект',
        'instructor.pred.counter_activation': 'відповісти на дію супротивника',
        'instructor.pred.end_day': 'завершити фазу підготовки',
        'instructor.pred.pass': 'передати хід',
        'instructor.pred.purchase_tower': 'захопити нову вежу',
        'instructor.purchase_tower_hint': "Спробуйте натиснути на область кристалів веж у нижній частині екрана, щоб захопити нову вежу кольору {colorName}!",
        'instructor.pred.mage_cast_spell': 'створити заклинання',
        'instructor.pred.accept_activation': 'прийняти ефекти',
        'instructor.pred.toggle_essence_mode': 'перейти в режим заробітку есенції',
        'instructor.pred.toggle_essence_mode_off': 'вийти з режиму заробітку есенції',
        'instructor.pred.start_tower_purchase': 'почати захоплення вежі',
        'instructor.pred.discard_stash': 'спалити її за есенцію',
        'instructor.pred.discard_hand_for_essence': 'скинути її для отримання есенції',
        'instructor.pred.astrid_blast': 'використати здібність героя',
        'instructor.astrid_blast_hint': "Спробуйте використати [Кнопку стріл Астрід], щоб завдати противнику неминучої шкоди! Для цього перетягніть стрілу з кнопки на аватар супротивника.",
        'instructor.pred.default': 'зробити оптимальний хід',
        'instructor.flip_first': 'Перш ніж використовувати карту [{elementName}], переверніть її на сторону [{targetSideName}] (коліщатком миші або іконкою зі стрілочками).',
        'instructor.drag_to_prepare': 'Підготуйте карту [{elementName}], перетягнувши її в порожній слот підготовки.',
        'instructor.tryPlaying': 'Спробуйте зіграти карту {cardName}, щоб {prediction}.',
        'instructor.tryPlayingTarget': 'Спробуйте зіграти {cardName}, щоб {prediction}. Для цього перетягніть {cardName} на ціль.',
        'instructor.tryClicking': 'Спробуйте натиснути {elementName}, щоб {prediction}.',
        'instructor.close': 'Закрити (цю пораду)',
        'instructor.turnOff': 'Вимкнути Інструктора',
        'instructor.drag_arrow_hint': 'Спробуйте протягнути стрілку від карти до аватара цілі, затиснувши на самій карті курсор миші або палець.',
        'instructor.title': 'Порада Інструктора',
        'instructor.chooseLockedCardReturn': 'Схоже, у вас більше заблокованих карт, ніж слотів. Виберіть [{elementName}], щоб повернути її в руку.',
        'instructor.chooseBurglaryCard': 'Виберіть [{elementName}] з руки супротивника.',
        'instructor.chooseColor': 'Виберіть колір [{colorName}].',
        'instructor.choosePurificationTarget': 'Виберіть вежу кольору [{colorName}].',
        'ui.on': 'Увімк',
        'ui.off': 'Вимк',
        'admin.title': "Архів Командира (Admin)",
        'admin.back': 'Назад',
        'admin.enterCode': 'Введіть код Командира:',
        'admin.wrongCode': 'Невірний код. Охорона повідомлена.',
        'admin.tie': 'Баланс (Нічия)',
        'admin.zones': 'Управління Зонами',
        'admin.zone': 'Зона',
        'admin.pointsUpdated': 'Очки Зони {id} оновлено!',
        'admin.pointsFailed': 'Помилка оновлення',
        'admin.siegeTitle': 'Облога Зони 4',
        'admin.heroId': 'ID Героя:',
        'admin.startSiege': 'Почати Облогу',
        'admin.siegeResetWarning': '* Початок події скине таймер на 0.',
        'admin.siegeStarted': 'Облога почалася з героєм {id}!',
        'admin.siegeFailed': 'Помилка запуску',
        'admin.veriskMonitor': 'Монітор Verisk',
        'admin.weakest': 'Найслабший:',
        'admin.strongest': 'Найсильніший:',
        'admin.zone4Owner': 'Власник Зони 4:',
        'admin.veriskCondition': 'Умова Verisk:',
        'admin.veriskHolders': 'Власники Verisk:',
        'admin.conditionMet': 'ВИКОНАНО',
        'admin.conditionNotMet': 'НЕ ВИКОНАНО',
        'admin.none': 'Немає',
        'admin.neutral': 'Нейтрал',
        'admin.userAccess': 'Права Доступу',
        'admin.makeAdmin': 'Зробити Адміном',
        'admin.adminSuccess': '{user} тепер Адмін!',
        'admin.loading': 'Завантаження Архіву...',
        'admin.advanced': 'Розширене управління',
        'admin.resetAll': 'Скинути Прогрес (Всі)',
        'admin.deleteAll': 'Видалити Всіх (Крім мене)',
        'admin.resetUser': 'Скинути Прогрес',
        'admin.deleteUser': 'Видалити Користувача',
        'admin.banUser': 'БАН',
        'admin.unbanUser': 'РОЗБАН',
        'admin.confirmResetAll': 'Скинути прогрес ВСІХ гравців? Скасувати неможливо.',
        'admin.confirmDeleteAll': 'Видалити ВСІХ користувачів крім вас?',
        'admin.confirmAction': 'Ви впевнені, що хочете {action} користувача {user}?',
        'admin.actionSuccess': 'Успішно!',
        'admin.userNotFound': 'Користувача не знайдено.',
        'error.banned': 'Акаунт заблоковано через підозрілу активність.',

        // Notifications
        'notif.title': 'Сповіщення',
        'notif.noNotifications': 'Немає сповіщень',
        'notif.markAllRead': 'Позначити все як прочитане',
        'notif.clearAll': 'Очистити все',
        'notif.zoneCaptured': 'Зона {zone} захоплена фракцією {faction}!',
        'notif.heroBelongs': 'Герой "{hero}" тепер належить {faction}',
        'notif.factionCapturedTavern': 'Наша фракція захопила таверну (Зона {zone})! Герой "{hero}" тепер назавжди в нашій колекції!',
        'notif.factionReinforcements': 'Нашій фракції прийшла підмога! Перевір свою колекцію героїв! Герой {hero} допоможе нам просунутися на карті світу!',
        'notif.opalstoneGift': 'Подарунок за введення Opalstone ID! Новий герой "{hero}" у твоїй колекції!',
        'notif.accountBlocked': 'Ваш акаунт було заблоковано адміністратором.',
        'notif.accountUpdate': 'Оновлення акаунту: {message}',
        'notif.global': 'Глобальне',
        'notif.faction': 'Фракція',
        'notif.individual': 'Особисте',
    },
};

export const t = (key: string, lang: Language, params?: Record<string, string>): string => {
    let result = (TRANSLATIONS[lang] as any)[key] || (TRANSLATIONS['en'] as any)[key] || key;
    if (params) {
        Object.entries(params).forEach(([k, v]) => {
            result = result.replace(`{${k}}`, v);
        });
    }
    return result;
};

/**
 * Parses a special localized log string format: "t:key|param1=val1|param2=val2"
 * If it's not in this format, returns the original string.
 */
export const parseLog = (log: string, lang: Language): string => {
    if (!log.startsWith('t:')) return log;

    const parts = log.substring(2).split('|');
    const key = parts[0];
    const params: Record<string, string> = {};

    for (let i = 1; i < parts.length; i++) {
        const [k, v] = parts[i].split('=');
        if (k && v) params[k] = v;
    }

    // Attempt to translate cardType if it exists
    if (params.cardType) {
        // 1. Try to translate as a card name (using faceSlug)
        const cardNameKey = `card.${params.cardType}.name`;
        const translatedName = t(cardNameKey, lang);
        
        if (translatedName !== cardNameKey) {
            params.cardType = translatedName;
        } else {
            // 2. Fallback to generic term (e.g. term.attack)
            const genericKey = `term.${params.cardType.toLowerCase().replace(/_/g, '-')}`;
            const translatedGeneric = t(genericKey as any, lang);
            if (translatedGeneric !== genericKey) {
                params.cardType = translatedGeneric;
            }
        }
    }

    return t(key, lang, params);
};
